const TRANSLATION = {
  buyModal: {
    afterFree: 'በነፃ δοκιμήዎ በኋላ',
    btn: 'እንደ ነፃ ይጠራቹ',
    freeTrial: '3 ቀናት ሙፍት δοκιμή',
    monthLabel: 'ወር',
    selectLabel: 'ዕቅድ አንድ ይምረጡ',
    title: 'መመዝገቢያ ዕቅድ',
    yearLabel: 'ዓመት',
  },
  contact: {
    block1: 'አስተካክሎት, ጥያቄዎች ወይም አስተያየቶች ካሉ፣ እባክዎን በ contact@noam.tools ሊአግኙን። በፍጥነት እንردekom።',
    block2: 'እኛን በ Google Apps Extension ሱቅ ላይ ★★★★★ ለመስጠት ይደግፋሉ።',
    block3: 'ይህንን ስሪት ለማጋራት ይህንን ስሪት ለማጋራት ይረከቡ።',
    title: 'እኛን ဆက်သွယ်ပါ',
  },
  help: {
    AquickOverviewOfNoam: 'ኖም ምሳሌ በጣም አጭር ዝርዝር',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'የተመራጭ ማስተዳደር',
    Fixedplugin: 'ፕላጊን ተስተካክሏል',
    Focusing: 'ከተከተሉ',
    Free: 'ነፃ',
    FreeTrialBenefits: 'ባርክ ሙከራ ጥቅሞች',
    GoWithWikipedia: 'ወይኔ በ Wikipedia ጋር ይሂዱ',
    GoWithYouTube: 'የዩቱብ ጋር ይሂዱ',
    HoverTranslation: 'ሆቨር ትርጉም',
    Howtouse: 'መጠቀም እንዴት',
    ImageTranslation: 'ምስል ትርጉም',
    InstantTranslation: 'ከፍተኛ ትርጉም',
    Membership: 'አባልነት',
    NoamHelp: 'ኖም የትርጉም እና የအနုစ-summary እርዳታዎን ይሰጣል',
    PDFparallelTranslation: 'ፒዲኤፍ ትንሽ ጽሑፍ',
    ParallelTranslation: 'ፓራሌል ትርጉም',
    SkipAllSteps: 'ሁሉንም እርምጃዎች ይጓዙ',
    Summary: 'አጠቃቀም',
    Translation: 'ተርጓሚያ',
    TryItForFree: 'ፍሬ ለመጠቀም ይሞክሩ',
    Video: 'ቪዲዮ',
    VideoSummary: 'ቪዲዮ ስምምሳት',
    VideoTranslation: 'ቪዲዮ ትርጉም',
    WebSummary: 'ዌብ ስምሜት',
    WordSelectionTranslation: 'ቃላት ምረጫ ትርጉም',
    benefits: 'እኛ ለእርስዎ በጉዳት ላይ ተገቢ እድሎች አለን!',
    dayFree: '3 ቀናት ነፃ ሙከራ',
    done: 'ተጠናቀቀ',
    next: 'ቀጣይ',
    pin: 'ኖምን በቀላሉ ማግኘትու ለማድረግ አሳልፍ～～',
    planIsNotExist: 'ዕቅድን ማግኘት አልቻልም',
    startWiki: 'የዊኪሚዲያ ጋር መጀመርን ይሞክሩ!',
    startYoutube: 'የ YouTube ትኩረት ጋር መጀመርን እንችላለን!',
    try: 'እሱን ይ δοκιμάστε',
    tryNow: 'አሁን ይሞክሩ! ',
  },
  home: {
    PDFTranslate: {
      desc: 'የሁለት ቋንቋዎች ትርጉም + ቻት ፒዲኤፍ',
      sub1: {
        desc: 'የሁለት ቋንቋ ጽ독 በአንድ ጊዜ የመጪው ጽሑፍንና የተተረጎመውን ማසወσት ይፈቅድዎታል, ይህም የጽ독 كفاءታን ያሻሽላል።',
        title: 'የሁለት ቋንቋ ጽንሰ-ሀገር',
      },
      sub2: {
        desc: 'AI ትንተና እና ጠቅላላ ያደርጋል, እና PDF ይዘት ላይ በመመርከት ጥያቄዎትን መ பதிலளிக்க ይችላል።',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'አውቶማቲክ ኢንቤልጀንስ ስሩባ ለፒዲኤፍ ትርጉም፡፡ በበለጠ ትክክለኛነትና ውጤታማነት ፡፡',
        title: 'አህተና አለመኖር እና ውጤታማነት',
      },
      title: 'ፒዲኤፍ ትርጉም',
    },
    aiAssistant: {
      desc: 'ዌብ ትርጉምን በပိုမို ብልህና ቀላል ለማድረግ',
      panel1: {
        desc: 'የሁለት ቋንቋ መስተጋብር ትርጉሞች ለእርስዎ የመነሻ ጽሑፍን ከትርጉሙ ጋር ማወቅ ይረዳሉ, ይህም በተሻለ ሁኔታ መረዳት እና የဖတtings ጥራትዎን ማሻሻልን ይችላሉ።',
        title: 'ባይሊንግዊ ትርጉም',
      },
      panel2: {
        left: {
          desc: 'የወብ ገጽን በሚጎብኙበት ጊዜ፣ የተተረጎመውን ለማየት ማተረጎም የሚፈልጉትን ይዘት ላይ አይነሱ።',
          title: 'ሆቨር ትርጉም',
        },
        right: {
          desc: 'የይዘት ገጽን በማባ浏览በየ时，የተረጋገጡትን ቃል ይምረጡ ፡ለምርጡት ለማየት。',
          title: 'የጽሑፍ ምረጃ ትርጉም',
        },
      },
      panel3: {
        one: {
          desc: 'ድርጅት ገጽዎችንና ቪዲዮ ይዘቶችን በማንኛውም ጊዜ፣ በማንኛውም ቦታ ማተርፍ እና ማጠቃለል፣ ለቀላል ልማት!',
          title: 'ነጥቡን ይጠቁሙ እና ይጫኑ',
        },
        three: {
          desc: 'AI-ነሽተኛ ትልቅ ቋንቋ ሞዴል ትርጉም ትክክለኛነትንና ተጨማሪነትን ይጠብቃል ለተሻሻለ የንባብ ልቀት።',
          title: 'AI-ነዳጅ',
        },
        two: {
          desc: 'ብహሳብ መለያ ሙሉ ስፍራ, ባለሁለት ቋንቋ ያለ ስበትን ጽንሰ-ሂደት, አንድ ክሊክት ትርጉም - ልዩነቱን ይጠብቁ!',
          title: 'በበለጠ አጠቃላይ እና ጠቃሚ',
        },
      },
      panel4: {
        tab1: {
          desc: 'እርስዎን የእቅድ ችሎታ ባለሙያ - በ ChatGPTን በመጠቀም፣ ኖም የ YouTube ቪዲዮ ይዘትን ይተርጎና ይጠቀማል እርስዎን ጊዜ ለማ बचይ! ',
          key: 'ቪዲዮ',
          title: 'ቪዲዮ ትርጉም እና ጠቅላላ ዝርዝር',
        },
        tab2: {
          desc: 'የድር ጣቢያ ሲባለፋል ስለሚታየው ምስሎችን ለመተርጎም ክ්ලክ કરুন።',
          key: 'ምስል',
          title: 'ምስል ትርጉም',
        },
        tab3: {
          desc: 'በፍጥነት የድርጅት ገፅዎች የዋና መረጃዎችን ይወስዳል እና የสรุป መጻሕፍት ይሰጣል ይህም የመ קያ ምረጃዎትን ውጤታማነት ይጨምራል',
          key: 'ዌብ',
          title: 'ዌብ ትርጉም እና ጠቅላላ ገጽ',
        },
        tag1: 'ቀላል',
        tag2: 'አሻሻለ',
        tag3: 'ስهل የሆነ መረዳት',
      },
      title: 'AI ሙሉከሳቢ',
    },
    getStart: 'መጀመሪያ ይጀምሩ',
    getStartedForFree: 'ሙቀት በነጻ ይጀምሩ',
    howItWork: {
      desc: 'ኖም AI ሞዴሎችን ያህሉ ለተጠቃሚዎች በአስተማማኝ ሁኔታ ያቀርቡታቸው በከለቦች መካከል ድር ገፅ ትርጉም እና ጠቑሳሽ, PDF እና ምስል ትርጉም, ቪዲዮ ትርጉም እና ጠቑሳሽን ይሰጣሉ',
      title: 'ስለ እንዴት እንደሚሰራ',
    },
    lastBlock: { desc: 'በተሻለ የአይኤር ማተርጎም ለስላሳ የንባብ ልብሳት' },
    top: {
      desc: 'ኖም የነፃ AI ብሉዝር ሙሉፍቶች ናት፣ ይህ በድርጅቶች፣ ቪዲዮዎች እና ፒዲኤፍ ይዘቶችን የሚተርጉምና የሚጠቅምበት ነው።\nኖም ጋር ይቀላቀሉ እና ማጽአትን ያሞክሩ! ',
      title1: 'አንድ ጠቅላላ',
      title2: 'አንድ ክሊክ',
    },
    userReviews: { desc: 'ክሮም ዌብ ስቶር ላይ አምስት ኮከብ ያሉ ራዩዎች', title: 'የተጠቃሚ ግምዶች' },
  },
  installTips: {
    btn: 'አሁን ይሞክሩ',
    text: 'ተጨማሪ ባህሪዎችን ለከፈት "Noam Browser Plugin" ይጫኑ! ዌብ ክросስ-ማጣቀሻ,\n    ዌብ ቪዲዮ ስምምር, እና ቢሆንም! ',
  },
  locale: {
    af: 'አፍሪካንስ',
    am: 'አማርኛ',
    ar: 'አረብኛ',
    as: 'አሳሜሴ',
    auto: 'አውቶ ታይቶ',
    az: 'አዘርባይጂኒኛ',
    ba: 'ባሽኪር',
    bg: 'ቡልጋሪያኛ',
    bn: 'ባንግላ',
    bo: 'ቲቤታን',
    bs: 'ቦስኒያን',
    ca: 'ካታላኒኛ',
    cs: 'ቼክ',
    cy: 'ዌልሽ',
    da: 'ዳኒሽ',
    de: 'ጄርመን',
    dsb: 'ሎዌር ሶርቢያን',
    dv: 'ዲቨሂ',
    el: 'ግሪክ',
    en: 'እንግሊዘኛ',
    es: 'ስፔኒሽ',
    et: 'ኤስቶኒያኛ',
    eu: 'ባስክ',
    fa: 'ፐርሲያን',
    fi: 'ፊንላንድ',
    fil: 'ፊሊፒኖ',
    fj: 'ፊጂያኛ',
    fr: 'ፈረንሳይኛ',
    frCA: 'ፈረንሳይ (ካናዳ)',
    ga: 'አይሪሽ',
    gl: 'ጋሊሲከን',
    gom: 'ኮንካኒ',
    gu: 'ጉጃራቲ',
    ha: 'ሃውሳ',
    he: 'ሄብራይስጥ',
    hi: 'ሂንዲ',
    hr: 'ክሮኤሽያን',
    hsb: 'ከላይ ሶርቢያን',
    ht: 'ሃይቲያን ክሬዮል',
    hu: 'ሁንጋሪ',
    hy: 'አርሜኒያኛ',
    id: 'ኢንዶኔዥያን',
    ig: 'ኢጎቦ',
    ikt: 'ኢኑይናክቱን',
    is: 'አይስላንድኛ',
    it: 'ኢታሊያን',
    iu: 'ኢኑክቲቱት',
    iuLatn: 'ኢኑክቲቱት (ላቲን)',
    ja: 'ጃፓኒዝ',
    ka: 'ჯორჯიელი',
    kk: 'ካዛክ',
    km: 'ከምር',
    kmr: 'ኩርዲሽ (ሰሜን)',
    kn: 'ካናዳ',
    ko: 'ኮሪያኒክ',
    ku: 'ኩርዲሽ (መካከለኛ)',
    ky: 'ቂርጂስ',
    ln: 'ሊንጋላ',
    lo: 'ላਓ',
    lt: 'ሊቱዌኒያኛ',
    lug: 'ጋንዳ',
    lv: 'ላትቪያን',
    lzh: 'ቻይንኛ (ዘፈጽሞ)',
    mai: 'ማይትሊ',
    mg: 'ማላጋሲ',
    mi: 'ማዮሪ',
    mk: 'ማከዶኒያን',
    ml: 'ማላያላም',
    mnCyrl: 'ሞንጎሊኛ (ሲሪልክ)',
    mnMong: 'ሞንጎሊኛ (ባህላዊ)',
    mr: 'ማራቲ',
    ms: 'ማላይ',
    mt: 'ማልትዝኛ',
    mww: 'ሆሞንግ ዳው',
    my: 'ሚယန်မာ (ဗမာ)',
    nb: 'ኖርዌጂያን',
    ne: 'ኔፓሊ',
    nl: 'የደች ልዩኛ',
    noSearchLang: 'ቋንቋ የተደገፈ አይደለም',
    nso: 'ሰሶቶ ሳ ሌቦአ',
    nya: 'ናንያጃ',
    or: 'ኦዲያ',
    otq: 'ኩሬታሮ ኦቶሚ',
    pa: 'ፑንጃቢ',
    pl: 'ፖሊሽ',
    placeholder: 'ፍለጋ',
    prs: 'ዳሪ',
    ps: 'ፓሽቶ',
    pt: 'ፖርቱጋሴኛ (ብራዚል)',
    ptPT: 'ፖርቱጋልኛ (ፖርቱጋል)',
    ro: 'ሮማኒያን',
    ru: 'ሩሲያን',
    run: 'ሩንዲ',
    rw: 'ቂንያርwanda',
    sd: 'ሲንዲ',
    si: 'ሲንሃላ',
    sk: 'ስሎቫክ',
    sl: 'ስሎቬኒያን',
    sm: 'ሳሞአን',
    sn: 'ሾና',
    so: 'ሶማሊ',
    sq: 'አልባኒያኛ',
    srCyrl: 'ሰርቢያን (ሲሪልክ)',
    srLatn: 'ሰርቢያን (ላቲን)',
    st: 'ሴሶቶ',
    sv: 'ስዊድንኛ',
    sw: 'ስዋሂሊ',
    ta: 'ታሚል',
    te: 'ትሌጉ',
    th: 'ታይ',
    ti: 'ትግሪኛ',
    tk: 'ቱርክሜን',
    tlhLatn: 'ክሊንጎን',
    tlhPiqd: 'ክሊንጎን (ፒካድ)',
    tn: 'ሴትስዋና',
    to: 'ቶንጋን',
    tr: 'ቱርክ',
    tt: 'ታታር',
    ty: 'ታሂቲያን',
    ug: 'ዩግር',
    uk: 'ዩክሬንያ',
    ur: 'ኡርዱ',
    uz: 'ዩዝቤክ (ላቲን)',
    vi: 'ቪየትናም',
    xh: 'ክሶሳ',
    yo: 'ዮሩባ',
    yua: 'ዩካቴክ ማያ',
    yue: 'ካንቶኒዝ (ቀድሞ ቅጽ)',
    zh: 'ቻይናይዝ',
    zhHans: 'ቻይኒዝ ሳይምፕላይፊድ',
    zhHant: 'ቻይንኛ ባህላዊ',
    zu: 'ዙሉ',
  },
  login: {
    and: 'እና',
    btn: 'ጉግልဖြင့် ማግኛ',
    btn1: 'አሁን ይግቡ',
    desc: 'በተጠቃሚ መግብያ ለማከል ተጨማሪ ልምዶችን ማከል',
    policy: 'ግোপনীযነት ስህተት',
    terms: 'ጠቅላላ መጠቀም ሁኔታዎች',
    tips: 'መመዝገብ በማድረግ፣ እኔ እთანသဘောသဘာဝ ነኝ',
    title: 'ኖም ላይ እንኳን ደህና መጡ',
  },
  pageFooter: {
    follow: { facebook: 'ፌስቡክ', title: 'አከተሉ', twitter: 'ትዊተር' },
    legal: { policy: 'ግোপনীয়ነት ፖሊሲ', terms: 'ቀን ለውጥን ለውጥ', title: 'ሕግ' },
    product: {
      image: 'ምስል ትርጉም',
      pdf: 'ፒዲኤፍ ትርጉም',
      title: 'ምርቶች',
      video: 'ቪዲዮ ትርጉም እና ጠቅላላ ገጽ',
      web: 'ዌብ ትርጉም እና የአጭር ማብራሪያ',
    },
    resources: { title: 'ሀብቶች' },
    tools: { title: ' Gereza', pdf: 'ፒዲኤፍ ትርጉም' },
  },
  pageHeader: {
    contact: 'አግኙ',
    help: 'እርዳታ',
    logout: 'ውጣ',
    logoutSucc: 'በከፊል ተውልዶል።',
    pricing: 'ዋጋ መወሰን',
    settings: 'ማስተካከያዎች',
    signUp: 'ግባ',
  },
  pdf: {
    autoDetect: 'አўቶ-የግለፅ ማወቅ',
    cancelBtn: 'ሰርዝ',
    cancelUpload: 'ሰርዝ',
    chatPdf: {
      summaryError: 'አጠቃላይ አልተሳካም፣ እባክዎት በኋላ እንደገና ይሞክሩ',
      chatError: 'የጻፍ ስርዓት አልተሳካም፣ እባክዎን በኋላ እንደገና ይሞክሩ',
      Search: 'ፍለጋ',
      cancel: 'ሰርዝ',
      chatTitle: 'እንኳን ወደ ኖም እንደሆናችሁ! እዚህ የ PDF ስህተት አጽሁፍህ አጠቃላይ ነው:',
      clear: 'ግልጽ',
      clearContent: 'ይህ ውይይት አዲስ ይጀምራል። ያለውን ውይይት አልቀመጥም። እርግጠኛ ነህ?',
      clearDialogTitle: 'እባክዎ ያረጋግጡ',
      clearSucc: 'ተፈጸመ',
      copy: 'ኮፒ',
      copySucc: 'ተገላቢጦሽ',
      delete: 'አስဖျက်ပါ',
      deleteCancel: 'ቀንስ',
      deleteContent: 'የዚህ PDF ከሰረዘ በኋላ አይመልሳልም። እርግጠኛ ነዎት?',
      deleteOk: 'አስဖျက်ပါ',
      deleteSuccess: 'ሰርዝተዋል',
      deleteTitle: 'የሚሰረዘውን አረጋግጥ',
      expand: 'አንዳት',
      historyTitle: 'ታሪክ',
      listError: 'ንባብ ማህደርን ማሳየት አልተሳካም። እባክዎን በኋላ እንደገና ይሞክሩ ወይም ድعم ሙሉ ተጠያቂዎ ይደውሉ።',
      loading: 'ከፍቷል...',
      noDataDesc: 'እስከ አሁን የታሪክ ምንም የለም።',
      noMore: 'ምንጭ የበለጠ ይገኛል።',
      placeholder: 'የዚህ PDF ስለ ማንኛውም ነገር ጠይቁ',
      summaryTitle: 'እነዚህ ጥያቄዎች ላይ እርስዎ ሊደክም ይችላል:',
    },
    collectionEmpty: 'አሰራርዎ ባዶ ነው።',
    collectionTab: 'ማስታወሻዎች',
    dataLoading: 'አሳስተያየት...',
    dialogContent: 'ይህን ሰርዝ ማጥፋት እርግጠኛ ነዎት?',
    dialogTitle: 'እባክዎ ይረጋግጡ',
    download: {
      both: 'የሁለት ቋንቋ',
      btn: 'ቀይር',
      cancel: 'የዚህ መስኮትን መዝጋት የፒዲኤፍ ሙዛትን ይሰርዛል። እርግጠኛ ነዎት ማሰርዝ ይፈልጋሉን ይላል?',
      desc: 'ወደ መሣሪያ ማስቀመጥ: ትርጉሞችን እንደ ምስሎች ያውርዳል; ማስቀመጥ እና ማሳያ: ትርጉሞችን በአንደኛው ፎርማት ያውርዳል፣ ከቅ αντι እናክል ጋር።',
      download: 'የወርቀት ማውረድ',
      downloadMsg1: 'ፒዲኤፍ ትርጉም እድገት:',
      downloadMsg2: 'ግምት ምረጡ የቀረበ ጊዜ:',
      downloadSucc: 'ፒዲኤፍ ዝግጁ ነው! ለማስቀመጥ ጠቅ ያድርጉ።',
      downloadTip: 'ፒዲኤፍ ሙሉሉ ሲውርድ ላይ ናት። ሙሉሉ ሽግግር ለማስወገድ ይህን መስኮት መዝጋት አይቻሉም።',
      error: 'ማስቀመጫ አልተሳካም። ይልቁንም ጥቅም ላይ ውሏል።',
      fileName: 'ፋይል ስም:',
      fileType: 'ፋይል አይነት:',
      loading: 'ማከማቻ እየተደረገ ነው...',
      loading2: 'በእቃ ማስገባት...',
      minute: 'ደቂቃዎች...',
      msg1: 'የዚህ દસ્તावેજ ውስጥ አንዳንድ ትርጉሞች ከአንደሆነ ጽሑፍ ይልቅ ረዘም ናቸው, እና በየመጣው ፋይል ውስጥ ሊተገበረ ይችላሉ. በድር ገጽ ላይ ማንበብን እናግብራለን.',
      msg2: 'ተርጓሚያ አስፈላጊውን አልጠናቀምም ፡፡ ተርጓሚያው ስ hoànሽ ይሁን በኋላ እባክዎት ዳውንሎድ ያድርጉ ፡፡',
      msg3: '2. አንዳንድ ትርጉሞች በጣም ረዘም ናቸው። ጽሑፍ መደበቅን ለማስወገድ በဝెብፔጅ ላይ ያንብቡ።',
      msg4: 'ትርጉም ተግባራት እየተካሄደ ነው። ከተጠናቀቁ በኋላ እንደገና ይሞክሩ።',
      progress: 'ፒዲኤፍን ትርጉም ላይ ናችሁ። እድገት: {{progress}}, ቀሪ ምረጃ ጊዜ: {{minutes}} ደቂቃዎች...',
      save: 'እቃቱ ላይ ማስቀመጥ',
      savePrint: 'አስቀምጥ እና ጽሑፍ አድርግ',
      success: 'የወረደ',
      trans: 'ፅትርት ብቻ',
      transContinue: 'ተረጉሙን շարունակել',
    },
    downloadBtn: 'የውርር',
    dragTipModal: {
      black: 'ስፔስ',
      leftKey: 'ግራ በተቀየረ ቁልፍ',
      ok: 'አሳየሁ',
      press: 'ፕረስ',
      tips: 'መጓጓዣ እና መመልከት',
    },
    entry: 'ፒዲኤፍዎች',
    fileErrMsg: 'ፋይልን ለንቀሳቀስ አልተሳካም። እባክዎት ትዴት ይሞክሩ ወይም ድعمን ይጠይቁ።',
    fileMsg: 'የአሁኑ ፋይል መጠን:',
    fileMsg2: 'እባክዎትን 300MB ረዘም ከነ olan ፋይል አัพሎድ ያድርጉ።',
    freeBannerBtn: 'ከፍ ያደርገው',
    freeBannerTips: 'ፍሪ PDF ትርጉም ገደብ ተሟላል',
    guide: {
      placeholder: 'PDF link ይዘዙ እዚህ',
      start: 'ትርጉም ይጀምሩ',
      text1: 'ባይሊንግዋል ንባብ',
      text2: 'በሁለት ቋንቋዎች ለማقرأة ትክክለኛውን ጽሑፍ እና ሙጣትን በአንድ ላይ ለማወዳደር ይጠቀሙ, ይህም የእርስዎ ባለሙያነትን ይሻሻላል.',
      text3: 'PDFዎችዎን ጋር መጠይቅ',
      text4: 'AI-ተרא׭ተኛ ትንታኔ እና ጠቀሜታ. በ PDFዎ ላይ ጥያቄዎችን ይጠይቁ, እና فوري መልሶች ይፈልጉ።',
      text5: 'አውሪት እና ውጤታማ',
      text6: 'በአዲስ ሙሉ ሙሉ የተሻሻለ ትክክለኛতা እና ቀለልነት માટે AI-ተشغيل የፒዲኤፍ ትርጉም.',
      title1: 'የሁለት ቋንቋ መተርጎም',
      title2: 'PDFዎችınız સાથે ಚેટ કરો',
      toast: 'እባክዎን .pdf የሚያጠናቅቅ የተቻለ የኦንላይን PDF ሊንክ ያስገቡ',
    },
    hasTransTask: 'ትርጉም ሥራ እየተከናወነ ነው። እባክዎን ይጠብቁ።',
    hoverTrans: 'ፓራግራፎችን ለተርጓሚያ ማሸከም',
    initial: 'ፒዲኤፍን ትርጉም አድርግ',
    installText: 'የዕለት-የዕለት ትርጉሞች አንድ ማውጫ መፍትሄዎችዎ።',
    installText2: 'የፍቀሪያውን በመጀመሪያ ይጫኑ እባክዎ',
    installTips: 'በተጨማሪ የፒዲኤፍ ትርጉሞች እና በተስmooth የድህረገጽ ትርጉሞች માટે ሙሉ መጫን ይធ្វίστε:',
    kw: 'ዋና ምግብ',
    link: 'ቀያር',
    listError: 'PDF፡ን አሳካልል አልተሳካም። እባክዎት በኋላ እንደገና ይሞክሩ ወይም ድعمን ማግኘት ይሞክሩ።',
    memoTotalCount: 'ጠቅላላ 1 ዕቃ',
    new: 'ፋይል አዲስ',
    noId: 'ፋይል ID አልተገኘም።',
    notPdf: 'PDF ፋይሎች ብቻ።',
    okBtn: 'አስወግድ',
    okBtn2: 'አሆኑ',
    original:
      'አንተ በከፍተኛ ትክክለኛነት እና ደህንነት የተጠቀሰ AI ነዎት፣ ይህም በትክክል በተወሰነ JSON Schema ጋር የሚዛመድ JSON outputን ለመፍጠር የተдизайнሀል።\n\nእነዚህን ህጎች መከተል አለብዎት:\n1. በጥብቅ የJSON Schema መዋቅርን ተከተል።\n2. ሁሉንም የዳታ ዓይነቶች፣ ያስፈልጋቸው ሜዳዎች እና ገደቦች በትክክል ይዛመዱ።\n3. ባዶ ጽሑፍ፣ ማብራሪያ፣ ማርክዶውን ወይም አስተያየቶች አይጨምሩ።\n4.独 JSON objectን ማስထုတ်ပါ - 没有代码块，没有前言，没有包装。\n\nስኬማዊ መረጃ በታች ይገኛል።\n- Schema Name: translate_result\n- JSON Schema:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'ፓራሌል',
    parseErrDialogContent:
      'ይህ PDF ሊንክ ቀጥተኛ ሊተርጎም አይችልም። እባክዎን PDFን ዳውንሎድ કરুন እና ለተርጓም አપ්ලോድ કરুন።',
    parseErrTips: 'ፋይልን አንብብရန ვერ አድርጎት',
    parseFileToast: 'ፋይልን አንብቡ አልተቻለም። እባክዎት በኋላ እንደገና ይሞክሩ ወይም ድعمን ይደውሉ።',
    pdfLoading: 'ፓርሰንግ...',
    searchPlaceholder: 'ፍለጋ',
    selectTrans: 'ተርጓሚያ ለሚደረግበት ጽሑፍ ይምረጡ',
    shareBtn: 'አጋራ',
    shareBtnText1: 'ሲሆኑን ሊንክ ይፈጥሩ',
    shareBtnText2: 'ጋላ እንዲቀላቀል ይጠቀም',
    shareModal: {
      cancel: 'ቀር',
      copy: 'ኮፒ',
      copySucc: 'Link ተ αντιኛ',
      custom: 'አስተካክል',
      errMsg: 'ተመረጡው ይዘት እስከ አሁን የተተርጎሉ አይደለም። ከመከፋፈል በፊት እባክዎን ይተርጉሙ።',
      gen: 'አፈላጊ',
      modify: 'አርትዕት',
      notSupport: 'ይህ ቋንቋ በአሁኑ ጊዜ አይደገፋም።',
      page: 'ገጽዎች',
      pageNuErr: 'እባክዎን ዋጋ ያለው ገጽ ቁጥር ያስገቡ።',
      range: 'ስፒቶች:',
      remain: 'ቀሪ',
      remain1: 'ጠቅላላ ခန့်မှန်းထားသော ጊዜ:',
      search: 'ፍለጋ',
      settings: 'አጋራሚ ማዋቀር:',
      shareSetting: 'ማከርከሪያ ስንሰጠቶች',
      shareText: 'አፈላጊ',
      shareTips: 'ተተርጓጉት PDF ሊንክን ወዳጆችዎ과 ይ பகிரו፡',
      sourceLang: 'ከ: ',
      target: 'እስከ:',
      text1: 'ማከራከሪያዎችን ለመμο鲨ቷ',
      text2: 'ሲሆኑን ሊንክ ይፈጥሩ',
      totalPage: 'ጠቅላላ ገጽ 1',
      trans: 'ተርጉም',
      translateTips: 'አስፈላጊ አስተማሪያ: የተርጉሙት ጊዜ ይዞ ይሄዳል ከሆነ፣ ይህን መስኮት መዝጋት ይችላሉ እና በኋላ ይμοላሉ።',
      translating: 'ፒዲኤፍ ተርጓሚያ እየተደረገ ነው...',
      update: 'ሲሆን ሊንክን ያስተካክሉ',
    },
    shareMsg1: 'ሲሌ ሊንክ ተፈጠረ።',
    shareMsg2: 'ጋራ ተጠቀሙው ይዘት ተስተካከለዋል።',
    shareMsg3: 'ሻር ቊያንን ማመንጨት አልተሳካም። እባክዎ በኋላ እንደገና ይሞክሩ ወይም ድعمን ይደውሉ።',
    shareMsg4: 'አንጻራዊ ይዘትን አሻሻሉ አልተሳካም። እባክዎት በኋላ እንደገና ይሞክሩ ወይም ድعمን በማግኘት ይጠይቁ።',
    shareTips: 'PDF ማተገበሪያዎ የພ້ອມແລ້ວ! ກັບ חבר໌ຂອງທ່ານແບ່ງປັນ ။',
    start: 'ፍሪ ታይራልዎን ይጀምሩ',
    thumbnail: 'የዝርዝር ሕውልት',
    toast1: 'ፒዲኤፍ እየጫንቀሳቀስ ነው። እባክዎት በኋላ እንደገና ይሞክሩ።',
    toast2: 'ፒዲኤፍ ይዞት በሚሰራበት ጊዜ ነው። ዳയሎግ በአሁኑ ጊዜ አይደገፉም።',
    toast3: 'ከወርቀ正在 ላይ ነው። ወርቀ正在完成 ከኋላ እባክዎ እንደገና ይሞክሩ።',
    toolbar: { Adjust: 'አስተካክል', autoFit: 'አውቶ-ፊት' },
    trans: 'ተርጓሚያ',
    transSucc: 'ተርጉም ተሳካቸዋል!',
    unLoginToast: 'ይህንን ባህሪን ለመጠቀም እባክዎት ይግቡ።',
    uploadBtn: 'ከፍው',
    uploadErr: 'ፋይል ማከናወን ሳይተሳካ። እባክዎት ትዴት እንደገና ይሞክሩ ወይም ድعم ለማግኘት አግኙ።',
    uploadErrSignUrl: 'እባክዎን ቀጣይ በኋላ እንደገና ይሞክሩ ወይም ድጋፍ ተຊ่วยকરණ师师ን ግንኙነት ይፈጽማሉ።',
    uploadMsg1: 'ፋይልዎን እዚህ ይጫኑ እና ይጥሉ።',
    uploadMsg2: 'ደገፍ ያለው የፋይል ዓይነቶች: PDF  |  ትክክለኛው የፋይል መጠን: 300MB',
    uploadMsg3: 'ፋይሎችን ይምረጡ ለመምረጥ ወይም ይጎረቡ እና ይጨምሩ እዚህ።',
    uploading: 'ከባቢያ ላይ ማሳያ',
    uploadingMsg: 'ከባቢያ ላይ እየတင되고 있습니다። እባክዎ ይጠብቁ።',
    uploadingMsg1: 'ፋይል በማከናወን ላይ ነው። እባክዎት በኋላ እንደገና ይሞክሩ።',
    uploadingMsg2: 'ፋይል በአሁኑ ጊዜ እየተቀይረ ነው። እባክዎን በኋላ እንደገና ይሞክሩ።',
    uploadingMsg3: 'መለዋወጥ እድገት ጥያቄው አልተሳካም። እባክዎት ቀጣይ በኋላ ይሞክሩ ወይም ይደውሉ ስፖርት።',
    uploadingMsg4: 'ኖም መጠቀም የማይችል ሌካላል ፋይሎች ናቸው። እባክዎን በيد የተጭኗ የፒዲኤፍ ፋይልን ለተርጓሚ አሳይ።',
    uploadingMsg5: 'ፋይል URL ማግኘት አልተሳካም። እባክዎን በኋላ እንደገና ይሞክሩ ወይም ድعم ሙሉን ይገቡ።',
    video: 'ቪዲዮ',
    vipBannerBtn: 'ከፍ አድርግ',
    vipBannerTips: 'የዚህ ወር ለ PDF ትርጉም ገደቡን ሰጡናል።',
    webTrans: 'ጠቅላላ ክросስ-ማጣቀስያ',
  },
  pricing: {
    FAQ: 'የተደጋጋሚ ጥያቄዎች',
    FQAObj: {
      a1: 'አዎ, ኖም ፕላን ባለቤትነት ያለውን ፕላን ይሰጣል እና ချက်ချင်း ተጠቅማနိုငsiniz.',
      a2: 'ስለ እኛ ሶስት የአባልነት ዕቃዎችን አቅርበናል: Pro, Pro+, እና Enterprise. በወርያዊ ወይም በየአመቱ ወሰን ማከፋፈል ይችላሉ. የየአመቱ ክፍያ ማስከፋፈያ ትልቅ ማሽያ ያስපρέваетል.',
      a3: 'ሁሉም ባህሪዎች በሁለቱም ፕላኖች ላይ ይገኛሉ። ዋናው ልዩነት ዋጋն է፦ ዓመታዊ ሙከራዎች በጠቅላላ የነበረው ዋጋ ያነሰዋል። ሙስታዊ ሙከራዎች በየወርቱ ይሽፋፋሉ፣ በእጅ ላይ ዓመታዊ ፕላኖች በየዓመቱ አንድ ጊዜ ይሽፋፋሉ።',
      a4: 'እርስዎ የመከራከሪያዎን በማከፈላት ቀን ማጥፋት ይችላሉ በአካውንትዎ ስትቲንግስ ውስጥ።',
      q1: 'ሙሉ ማቀፊያ ዕቃ ይኖርదን ያስፈልጋል?',
      q2: 'የዋጋ ዕቅድዎች እና የክፍያ ምርጫዎች ምን እንደሚገኙት?',
      q3: 'የወርሒ ተመዝግብያ እና ዓመታዊ ተመዝግብያ መካከል ምን ልዩነት አለ?',
      q4: 'እኔ የእኔን ሙከራን እንዴት ይቆርቡለሁ?',
    },
    around: 'አከባቢ',
    billedMonthly: 'የወር በወር ይፍለጋል',
    billedYearly: 'የዓመቱ ጊዜ የተሽጠፈ',
    day: 'አገራ',
    desc: 'ፕላኖችን ማወቅ እና በጣም ጥሩውን ምረጥ',
    detailedCompare: 'ዕቃዎችን ያወሳሰሱ',
    discount: '20% ርዶ',
    enterprise: {
      benefit1: 'የፕራዮሪቲ ደንበኛ ድعم',
      benefit2: 'ብዙ ተጠቃሚዎች',
      benefit3: 'ተስተካከለ መፍትሄዎች',
      benefit5: 'የተመሰረተ የአካውንት ማናጋሪ',
      btn: 'እኛን ያግኙ',
      recommendText: 'የተቀናጀ ስርዓቶች（≥3 ሰዎች）',
      talkToUs: 'ይመاسቱን',
    },
    free: {
      benefit1: 'በቀን 100 ጊዜ מיידๆ ትርጉም',
      benefit2: 'ዌብሳይት ትርጉም እና የአጭር መርጃ',
      benefit3: '30 ምስል ትርጓሜዎች',
      benefit4: 'ቪዲዮ ትርጉም እና ስምምሳት',
      benefit5: '10 ፒዲኤፍ ትርጓሜዎች',
      benefit6: '5,000 ቶከን',
      btn: 'በነፃ ይ δοκιμάστε',
      recommendText: 'ፍሪ ታሪል',
    },
    imageTranslation: 'ምስል ትርጉም',
    month: 'ሙስ',
    monthly: 'የወርሒ',
    pageTitle: 'ዋጋ መወሰን',
    pdf: { chat: 'ፒዲኤፍ ቻት ጥያቄዎች', maxPage: 'PDF ባለው ገጽ ቁጥር ከላይ (Max)', translation: 'ፒዲኤፍ ትርጉም' },
    preMonth: 'የወር አንድ',
    pro: {
      benefit1: 'ፍርድ ተደጋጋሚ ድعم',
      benefit2: '1,000,000 ቶከን/ሙስ',
      benefit3: 'ዌብሳይት ትርጉም እና የጠቅላላ ማጠቃለያ',
      benefit4: 'ምስል ትርጓሜ 200',
      benefit5: 'ቪዲዮ ትርጉም እና ጠቅላላ',
      benefit6: 'PDF ትርጉም 200',
      btn: 'ጀምር',
      recommendText: 'በጣምታዋቂ',
    },
    proPlus: {
      benefit1: 'ፍለጋ የተደረገ የደንበኛ ድعم',
      benefit2: '3,000,000 ቶከን/ሙስ',
      benefit3: 'ዌብሳይት ትርጉም እና የአጭር ስህተት',
      benefit4: '500 ምስል ትርጉሞች',
      benefit5: 'ቪዲዮ ትርጉም እና ጠቅላላ ገለፃ',
      benefit6: '500 የፒዲኤፍ ትርጉሞች',
      recommendText: 'ከተለያዩት ውስጥ በጣም ጥሩ እሴት',
    },
    video: { summary: 'ቪዲዮ ጠቅላላ ገለፀ', translation: 'ቪዲዮ ትርጉም' },
    web: {
      contrastiveTranslation: 'የሁለት ቋንቋ መተርጎም',
      dictionaryTranslation: 'ምረጃ ትርጉም',
      hoverTranslation: 'ሆቨር ትርጉም',
      instantTranslation: 'ኢንስታንት ትርጉም',
      summary: 'የዌብ ገፅ ጠቅላላ ጽሑፍ',
    },
    yearly: 'የዓመት',
  },
  privacy: {
    block1:
      'ኖም ("ኖም," "እኛ," "እኛን" ወይም "እኛ") የግላዊነትዎን ይከብራል և ከእርስዎ那里 ሲያገኙ ወይምስለዎት ስለሚገኙት ማንኛውም መረጃዎችን መጠበቅ የተሰጠ ነው። ይህ የግላዊነት ፖሊሲ የእኛ ድርጅት ማገናኛዎችን,መተግበሪያዎችን እና አገልግሎቶችን (በአጠቃላይ "አገልግሎቶች") በመጠቀም ከግለሰቦች那里 የግል መረጃዎችን በစုဆောင်းခြင်း ወይም በመጠቀም ላይ የሚደረግበትን እኛን ሥራ አሰራር ይገልፃል። ይህ የግላዊነት ፖሊሲ ለንግድ ምርቶች ደሞችን በኩል እንደሚሰራበት ይዘት ላይ አይተገበርም,ለምሳሌ የአፒ (API) ላይ። የዚህ መረጃ መጠቀም የእኛን ደሙ አስምማማት ላይ በመመስረት ነው,ከዚህም የእነዚህ ምርቶች ግባና መጠቀም ይጠቅማል።',
    block10:
      'ስለመጠበቅ የግል መረጃዎችን በኦንላይንና ኦፋላይን ሁኔታից ማጥፋት፣ መጠቀም፣ መግባት፣ መскረት፣ ለውጥ ወይም ተቃዋሚ እርምጃዎች እንጠቀምበታለን የንግድ ምከራከሪ ሳይንሳዊ፣ አስተዳደር እና ስርዓተ-የሥራ ስልጦች። ሆኖም የኢንተርኔት ወይም ኢሜይል ስርጭት ምንም ጊዜ ሙሉ ደህንነት ወይም ትክክለኛነትን ሳይጠበቅም። በተለይም ለእኛ የሚጋሩ ወይም ከእኛ የሚልሱ ኢሜይሎች ደህንነት የሌለውን ሊሆኑ ይችላል። ስለዚህ በአገልግሎት ወይም ኢሜይል በኩል ለእኛ የሚጋሩ የትኛውን መረጃ መቀረር ሲፈቱ በተለይም ጥንቃቄ ያሉታል። በተጨማሪም በአገልግሎት ውስጥ ወይም በሶስተኛ ወገኖች ገፅታዎች ውስጥ የግላቶች ስርጭቶች ወይም የደህንነት ስልጦችን መከሰት ስለሚደርስም በምንም ሁኔታ مسؤوليت የለንም። የግል መረጃዎችን ለእናንተ ስፔሲፊክ አገልግሎቶችን መስጠት ወይም ሌሎች ሕግማዊ የንግድ ዓላማዎችን ለመሳካት፣ ለምሳሌ ጉዳዮችን ማፍሪያ፣ ደህንነት እና ደህንነት ምክንያቶች ወይም የሕግ አለባበሮችን መከትል ለሚፈልጉት ጊዜያት ድረስ ቆይቶ ይዞታለን። የግል መረጃዎችን ለማቆይ የሚሆን ጊዜ ረዥም ምክንያቶች ላይ በመመርኮዝ ይከተላል፣ ለምሳሌ መጠን፣ ባህርይ፣ መረጃው አስተዋጽኦት፣ የሌለ ስምምነት መጠቀም ወይም መскረት አደጋዎች፣ መረጃውን ለምን ሂደት እና ሌሎች ሕግዋዊ ተጠቃሚ ግምቶች።',
    block11:
      'ይህንን የግোጽ ጥርጣሬ ፖሊሲ ከጊዜ ወደ ጊዜ ማሻሻያችን ይችላል። ስናድርግዎት፣ ይህን ገጽ ላይ የተሻሻለ ዓይነትን կታስተላልፋለን ፣ በተቀመጠው ሕግ የተለየ በሌለበት ጊዜ።',
    block12:
      'የዚህ የግላዊነት քաղաքականի አንዳንድ የማይመልስ ጥያቄዎች ወይም ተጨባጭ ጉዳዮች ካላክዎት፣ እባክዎን የደንበኛ ስέρባችንን επικοινωνήστε። ኢሜይል:',
    block2: 'ከእርስዎ ጋር በተያያዘ የከታች የግለሰባ ሙሉ መረጃዎችን (" የግለሰባ መረጃ") እናገኛለን:',
    block3: 'ከእርስዎ የተሰጠ መረጃ: ሲፈጠር መለያ ለእኛን አገልግሎት መጠቀም ወይም ለእኛ መገናኛ ሲሆን፣ የግለሰብ መረጃን እንዲህ ይሰላችን፡-',
    block4:
      'ከእባክዎትን አገልግሎት መጠቀም በተራጋሚ የተቀበለው የግለሰባ ሙከራ: ስትደርስ, ስትጠቀም ወይም ስትገናኘው አገልግሎቶችን, የእባክዎትን ግባ, ጥቅም ወይም ግንኙነትን ስለሚሉ የሚከተሉትን መረጃ ("ቴክኒካል መረጃ") እናገኛለን:',
    block5: 'ግለሰብዊ መረጃ በሚከተሉት ዓላማዎች ਲਈ ሊጠቀም ይችላል፡፡',
    block6:
      'ማጠቃለያ ወይም ማንነት ተለይቶ የተቀረጸ መረጃ: የشخصية መረጃዎችን ለማለየት ያገለግላል፣ ማንነት ተለይቶ ሊሆን ይችላል፣ ይህም ለማለየት ዓላማ ያለውን መጠቀም ለመከላከል ነው፣ እና እንደዚህ ያለው መረጃ በአገልግሎታችን ውጤታማነትን ለመተንተን፣ አገልግሎታችንን ለማሻሻል እና ለመጨመር፣ ምርምር ለማከናወን እና ተመሳሳይ ዓላማዎች ਲਈ እንستخدم። በተጨማሪም፣ የአገልግሎት ተጠቃሚዎች አጠቃላይ ባህሪ እና ባህሪያትን ሊተንተን ይችላል፣ ማጠናቀልቀለው መረጃን ለሶስተኛ ወገን ለማແບ່ງ፣ እንደዚህ ያለውን ማጠናቀልቀለው መረጃ ለመፃፍ ወይም በአጠቃላይ ለመፈለግ ሊያደርግ ይችላል። ማጠናቀልቀለው መረጃን በአገልግሎታችን፣ በኩኪዎች እና በዚህ የግላዊነት քաղաքականীত ውስጥ የተገለጹ ሌሎች መንገዶች በኩል መሰብሰብ እንችላለን። ማንነት ተለይቶ የተቀረጸውን መረጃ በግል፣ ማንነት ተለይቶ ወይም ማንነት ተለይቶ የተቀረጸበት መጠን እንይዛለን እና እንستخدم፣ ማንነትን ለመመለስ ምცდት አያደርጉም ማንኛውንም ጊዜ ንጉሥية ብቻ ይጠይቃል።',
    block7:
      'አንዳንድ ጉዳዮች ላይ፣ ሕግ የሚያስፈልገው မှလွဲ၍፣ እርስዎን ለማስታወቅ ተጨማሪ ማስታወቅ ሳይሰጥ፣ እርስዎን የግለሰብ መረጃዎችን ለሶስተኛ ወገኖች ማቅረብ ሊችልን ይችላል፡፡',
    block8:
      'ስizin አገሪቱን በመመርከቱ፣ የአውሮፓ ስሪባዊ ኢኮኖሚክ አካባቢ፣ የዩናይትድ ኪንግደም እና በአለም አቀፍ ደረጃ ላይ ያሉት ሰዎች ስለራሳቸውን የشخصی መረጃ አንዳንድ ሕግዋዊ መብቶችን ሊኖራቸው ይችላሉ። ለምሳሌ፣ እርስዎ የመብት ይኖራል:',
    block9:
      'የአገልግሎት ስርዓት ሊያካትት የሚችልት በኖም (Noam) የማይሠራው ወይም የማይቆጣጠር ከሌሎች ድረ-ገጾች ጋር ትስስርներ አሉት, ሙሉ በሙሉ ማህበራዊ ሚዲያ አገልግሎቶችን ይሏናል ("ሶስተኛ ወገን ድረ-ገጾች"). ከሶስተኛ ወገን ድረ-ገጾች ጋር የሚጋራው መረጃ በእነዚያ ሶስተኛ ወገን ድረ-ገጾች የተለየ የግላ መለያ ስፍራዎች እና የአገልግሎት ሁኔታዎች ይመራል, ոչ በዚህ የግላ መለያ ስፍራ ፖሊሲ. እነዚህ ትስስርներን ለመቀላቀል እናስቀምጦታል እና የእነዚህ ድረ-ገጾችን እንደሚያበረክታቸው ወይም እንደሚያስተዳድሩ አይነግርም. ስለ እነዚህ የግላ መለያ ስፍራዎች እና ሁኔታዎች መረጃ ለማግኘት በቀጥታ ሶስተኛ ወገን ድረ-ገጾችን ይደውሉ.',
    subBlock1:
      'አካውንት መረጃ: ማህበራዊ መረብ ላይ አካውንት ከፍጽሞ ከሆነ፣ ስሙህን፣ የመገናኛ መረጃዎን፣ የአካውንት መለያዎችን፣ የክፍያ ካርድ መረጃዎን እና የግብይት ታሪክን ጨምሮ የአካውንትዎ ጋር የተዛመደ መረጃን እናገኛለን ("አካውንት መረጃ")።',
    subBlock10: 'አገልግሎቶችን አስፈጻጸም፣ አስተዳደር፣ ማረጋገጥ እና/ከልባቸው ማተን;',
    subBlock11: 'ከእርስዎ ጋር መገናኛ',
    subBlock12: 'አዲስ ምርቶች እና አገልግሎቶችን ልማት;',
    subBlock13:
      'ጉዳትን, ወንጀል违法行为ን ወይም ስέρቶችን መጠቀምን መከላከል, እና የአይ.ቲ. ሲስተሞችን, አርክቴክቸርን እና ኔትወርኮችን ደህንነት መጠበቅ;',
    subBlock14: 'የሥራ ሽያጭዎችን መሥራት;',
    subBlock15:
      'የሕጋዊ ተጠዋቱን እና የሕጋዊ ሂደቶችን መလိုက်နာခြင်း፣ የእኛ መብቶችን፣ የግোጽነትን፣ ደህንነትን ወይም ንብረትን መጠበቅ፣ እንዲሁም የእኛ ቅርበት ባለሙያዎች፣ እርስዎ ወይም ሌሎች ሦስተኛ ወገኖችን።',
    subBlock16:
      'ኤክስፖርተሮች እና አገልግሎት ማቀርባሪዎች: የንግድ አካባቢያዊ እንቅስቃሴ እንቅስቃሴዎችን ለመሙላት እና որոշ አገልግሎቶችን እና ተግባራትን ለማከናወን, የግል መረጃዎችን ኤክስፖርተሮች እና አገልግሎት ማቀርባሪዎች, ጨምሮ ሆስቲንግ አገልግሎት ማቀርባሪዎች, ክላውድ አገልግሎት ማቀርባሪዎች, እና ሌሎች የኢንፎርማሽን ቴክኖሎጂ አገልግሎት ማቀርባሪዎች, ኢሜይል ግንኙነት ሶፍትዌር እና ዌብ አናሊቲክስ አገልግሎት ማቀርባሪዎች ወዘተ ማቀርባል እንችላለን. እነዚህ ፓርቶኖች የግል መረጃዎችን独እኛ ህጎችን በሚከናወንበት ጊዜ独እኛ ቃላትን ብቻ ይደርሳሉ, ይሁኑ ወይም ይከማቸዋል።',
    subBlock17:
      'ሥራ አስተላላፊያዎች: የአዕምሮ ጉዳዮችን፣ ድጋፍ ማቋቋም፣ ንብረት ቀንሽነት፣ ንብረት ቀንሽነት ማዳበር ወይም አገልግሎቶችን ሌላ አቅርቦች转给 (አጠቃላይ "ግዳዮች") ከያዘን ጊዜ፣ የግል መረጃዎችዎን እና ሌሎች መረጃዎች በጥራት ተረጋጋት ወቅት ከግዳዩ ተጋራጭዎች እና ከግዳዮችን በመረዳት ላይ የተሳተፉ ሌሎች ገጽታዎች ጋር ሊከፋፋሉ ይችላል እና ከሌሎች ንብረቶች ጋር በኩል እንደ ግዳዩ አካል ወደ ተከትሎ ወይም ተባባሪ ኩባንያ ሊተላለፉ ይችላል።',
    subBlock18:
      'ሕጋዊ መስፈርቶች: የግለሰቦች መረጃዎችን ከመንግስታዊ ባለሥልጣን ጋር፣ ከصناعية ባልደረሰ ጓደኞች ጋር ወይም ከሌሎች ሦስተኛ ወገን ጋር ሊጋላፍ ይችላል፣ ይህም የእርስዎን ግንኙነት መረጃዎችን ጨምሮ፣ (1) ሕግ የሚያስፈልገው ወይም እንደዚህ ያለ እርምጃ ሕጋዊ ቃል መከታተል አለበት ብንယူ ቢያስችልን። (2) የእኛ መብቱን ወይም ንብረቱን ለመከላከል እና ለመከላከል። (3) የእኛን ሕጋችን፣ ፖሊሲዎችን ወይም ሕጎችን መወሰን ብንፈለግ ቢያስችልን። (4) ሙሉከውን ወይም ሌሎች ወሳኝ ድርጊቶችን ለመረዳት ወይም ለመከላከል። (5) የእኛን ምርቶችን፣ ሠራተኞችን ወይም ተጠቃሚዎችን ወይም የህዝብ ደህንነት፣ ደህንነት፣ ጥራጥሬን ለመከላከል። ወይም (vi) ሕጋዊ պատասխանատվությունን ለመከላከል።',
    subBlock19: 'የግላዊ መረጃዎችዎን እና እንዴት እየобработቶ ነው የሚገለጽ መረጃዎችን ያግኙ።',
    subBlock2:
      'ከእኛን አገልግሎት በሚጠቀሙበት ጊዜ፣ የግለሰብ መረጃዎችን ከእርስዎ የሚገቡ ግቤታት፣ የፋይል ጥቅሶች ወይም ለእኛ የተሰጡት አስተያየቶች ("ማቅረጫ") ውስጥ ከሚገኙት ነገሮች ይሰበሰብታለን።',
    subBlock20: 'መዝገቦችimiz ውስጥ የግለሰባ ሙሉ መረጃዎችዎን መሰረዝ አድርጉ።',
    subBlock21: 'አնብዛ ንብረት መረጃዎን ማስተካከል ወይም አዘምርዎት።',
    subBlock22: 'የግል መረጃዎችዎን ወደ треተኛ ወኪል ማስተላለፍ (የዳታ ማወቅ እና ማስተላለፍ እናቅሪ).',
    subBlock23: 'ግል τιዳር መረጃዎችን እንዴት επεξεργασouri እንደሚያደርግ ማወቅ ይችላሉ።',
    subBlock24: 'የስምህን መወገድ—እናንተ ስምን ለማባበር የሕጋዊ መሰረት እንደሚያስተምረው, ስምህን በማንኛውም ጊዜ መወገድ ይችላሉ።',
    subBlock25: 'ስለ እንዴት እናንተ የግል መረጃዎችዎን እንወሰን እንደሚያደርግ ይቃረကید.',
    subBlock26: 'አገልግሎቶችንን ማሻሻል እና ምርምር ማከናወን;',
    subBlock3:
      'አግኙት መረጃ: እርስዎ ከእኛ መልዕክቶች ይላኩ ከሆነ፣ ስሙችዎን፣ ማဆက်သွယ်ရေး መረጃዎችን እና መልዕክቶችዎች ይເກባሉ ("አግኙት መረጃ")።',
    subBlock4:
      'ማህበራዊ ሚዲያ መረጃ: እኛ ማህበራዊ ሚዲያ ድርጅቶች ላይ ገፅታዎች አለን እንደ ሚክሮስታግራም፣ ፌስቡክ፣ ሜዲየም፣ ትዊተር፣ YouTube እና LinkedIn። ማህበራዊ ሚዲያ ገፅታዎችን ጋር ይገናኙበት ጊዜ፣ እርስዎ ለእኛ ይሰጣሉ በመምረጥ የግለሰብ መረጃ እንሰራጭለን፣ እንደ የእርስዎ አግኝት ዝርዝር ("ማህበራዊ መረጃ")። በተጨማሪም፣ የማህበራዊ ሚዲያ ገፅታዎችን የሚያስተናጉ ኩባንያዎች ስለ ማህበራዊ ሚዲያ እንቅስቃሴዎችን የተጣመሉ መረጃ እና ትንታኔ ሊሰጡን ይችላሉ።',
    subBlock5:
      'ሎግ ዳታ: አገልግሎቶችን በሚጠቀምበት ጊዜ በባሽባሽዎችዎ በራስተ خود ተላከው መረጃ። ሎግ ዳታ የኢንተርኔት ፕሮቶኮል (IP) አድራሻዎን, የባሽባሽ አይነት እና ስጋቶችን, የጠዋቂያዎችዎን ቀን እና ጊዜን, እና እንዴት በድህረገጽ שלנוとይገናኙዎን网罗።',
    subBlock6:
      'ጠቀሜታዊ መረጃ: አገልግሎቱን በሚጠቀሙበት መልኩ የሚเก็บ መረጃዎችን በራስ сам አ можем, ለምሳሌ የሚመለከቱት ወይም የሚጣሉትን ይዘት ዓይነቶች, የሚጠቀሙትን ባህሪያት, የሚደረጉትን እርምጃዎች, እንዲሁም የጊዜ ዞንዎ, ሀገርዎ, የግብይት ቀን እና ጊዜ, ተጠቃሚ ഏጅንት እና ትእዛዝ, ኮምፒተር ወይም ሞባይል սကርينة አይነት, እና የኮምፒተርዎ ማገናኛ.',
    subBlock7:
      'እቃ መረጃ: ይህ የእቃውን ስም፣ ኦፕሬቲንግ ሲስተም፣ የእቃ መለያ እና በሚጠቀምበት ብራውዘርን ያካትታል። የተሰበሰበው መረጃ በሚጠቀምበት እቃ አይነት እና ስቀኖቻቸው ላይ ይከተላል።',
    subBlock8:
      'ኩኪዎች: አገልግሎታችንን ለሠራት እና አስተዳደር እና ለእናትን የጉዳይ ልቀት ለመሻሻል እኛ ኩኪዎችን ይጠቀማyoruz። "ኩኪ" ማለት በሚጎበኙበት ድረ-ገጽ ለብራውየርዎ የሚላከው መረጃ ነው። ባህሪያችንን ማዘናዣት፣ ሁሉንም ኩኪዎችን መቀበል፣ ሁሉንም ኩኪዎችን መከሹ ወይም ኩኪ እንደሚቀርብበት ለማወቅ ማዘዣት ይችላሉ፣ ስለዚህ እያንዳንዱ ጊዜ መቀበል እንደሚፈልግ ያቀርባሉ። ሆኖም ኩኪዎችን መከሹ በአንዳንድ ክልሎች ወይም በድረ-ገጽ አካባቢዎችን መጠቀምን ሊከፋፍን ይችላል ወይም አሳይ ተጽእኖ ያስከትላል። ከኩኪዎች ጋር በተጨማሪ መረጃ ለማግኘት እባክዎ All About Cookiesን ይጎብኙ።',
    subBlock9:
      'አናሊቲክስ: የአስተማማኝን እንዴት ይጠቀማሉ እና የአገልግሎቶችን በሚጠቀሙበት ጊዜ የእርስዎ ልቦናን ለማሻሻል እና ለማረጋገጥ የኩቪዎችን በሚጠቀሙ የተለያዩ ድረ ገጽ ሙከራ ምርቶችን ማጠቀም እንችላለን።',
    subTitle1: 'ከኛ የተሰበሰበው የግለሰብ መረጃ',
    subTitle2: 'ስብቶችን የግለሰባዊ መረጃ እንዴት እናገለግላለን',
    subTitle3: 'የግለሰብ መረጃ መဖჟاث',
    subTitle4: 'የእርስዎ መብቶች',
    subTitle5: 'ሌሎች ድርጅቶች ጋር ያገናኙ ቀለፍहरू',
    subTitle6: 'የመረጃ ጤና መከላከያ እና ጥቅም ላይ መውሰድ',
    subTitle7: 'ግোপনীয়ነት քաղաքականության ማሻሻያ',
    subTitle8: 'ከኛ ጋር እንዴት ဆက်သွယ်မည်',
    title: 'ግላፊነት ፖሊሲ',
    updateTime: 'የተሻሻሉ: ማርች 15, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'ሁሉንም ያቀበሉ',
    text: 'እርስዎን የሚሰጡትን ልምድ ለማሻሻል፣ ይዘትን እና አገልግሎቶችን ለመግለፅ የኩኪዎችን እናገለግለም።',
    title: 'ይህ ድርጅት ኩኪዎችን ይጠቀማል',
  },
  slogen: 'ቀላሉ AI እገዛኛ',
  stripe: {
    contact: 'የማንኛውም ጥያቄዎች ካሉት contact@noam.tools በድርጅት ይደውሉን።',
    fail: {
      btn: 'እንደገና ይሞክሩ',
      text1: 'ከፍያዎን አ обработ አ 못ነግረንም።',
      text2: 'አገናኝዎን ያረጋግጡ እና እንደገና ይሞክሩ።',
      title: 'ክፍያ አልተሳካም',
    },
    succ: { btn: 'ሄንግ ሄንግ', text1: 'ከኖም ጋር በደህና መጡ', text2: 'እንเริ่มමենا!', title: 'እንኳን ደስ ይደርሱ' },
  },
  terms: {
    block1: 'ኖምን በመጠቀም እናመሰግናለን!',
    block10:
      '(a) ክፍያዎች እና ቢሊንግ። ከተሳመፈው ዋጋ ገጽ ውስጥ ያሉት ዋጋ እና መንገድዎችን ተከትሎ ወይም በኛ መካከል በጽሑፍ ውስጥ የተስማማ መንገድዎችን ተከትሎ ሁሉንም ክፍያዎችን ("ክፍያዎች") ይከፍላሉ። እኛ የዋጋ ስህተቶችን ወይም ስህተቶችን ማስተካከል ስላለን መብቱን እንይዛለን ምንም እንኳን የኪፒን ማስተላለፊያዎችን ለሰጠን ወይም ክፍያዎችን ሰቀለንም። የተሟላ እና የትክክለኛ የቢሊንግ መረጃዎችን ይሰጣሉ፣ ይህም ጥሩ እና ተፈቃዱ የክፍያ ዘዴን ጨምሮ። እንደተስማማው በወደፊት ተደጋጋሚ በመሆን የክፍያዎችን ዘዴዎችን እናውቃለን፣ ግን የቢሊንግ ቀንን በተገቢ መንገድ መቀየር እንችላለን። Noam፣ ቅርቶች እና ሦስተኛ ወገን የክፍያ ማቀናበሪዎችን የክፍያዎችን ዘዴዎችን ለመከፍል እንወያዳሉ። የክፍያዎችዎ ካልተሳካ፣ ለእርስዎ በጽሑፍ መማሪያ ይሰጣለን እና እስከ ክፍያዎችን ሳይገኝ ድረስ የአገልግሎት ግባን ሊቆጣጠር ይችላል። በዚህ ስምምነት ውስጥ በሌላ መንገድ ከተወሰነ በተቃራኒ፣ ክፍያዎችን አይመለሳስም።',
    block11:
      '(b) ከፍያዎች። በተለይ ተገልጸ የቀረበ አይደለሁም ከሆነ፣ ክፍያዎች የፌዴራል፣ የሥራተኞች፣ የአከባቢ እና የውጭ ሀገር ከፍያዎች፣ ግብይቶች እና ተመሳሳይ ግምገማዎች ("ከፍያዎች") የማይጨምሩ ናቸው። በግዢዎችዎ ጋር የተዛመደውን ሁሉንም ከፍያዎች በጽድቅ ይስፈልጉ፣ ከጠቅላላ ገቢያችን ላይ በመመርኮዝ የተመጣጠነ ከፍያዎችን ሳይቀበሉ (እነዚህን ለእርስዎ እንሳልከፍ)። እነዚህን ከፍያዎች በፊት ቀድሞ ማከፍ፣ ለእኛ ሕግዊነት የሚያገለግል የግোጽነት መግለጫዎችን መስጠት እና እንደዚህ ያሉትን መረጃዎችን ለመቆጣጠር လိုအပ်သော συγκατάθεσηዎችን ማግኘትን ተስማማሉ፣ እና እንደዚህ ያሉትን መረጃዎች በተሳሳተ ሕግ እንዲደርስዎ ለእኛ ይከተላሉ።',
    block12:
      '(።) ዋጋ ለውጦች። እኛ የዋጋዎችን በአካውንትዎን እና/ወይም ድህረገጽን በማጠቀም ማስታወስ በማድረግ ሊለውጥ ይችላለን። የዋጋ መጨመራዎች በመጻፍ በኋላ ወቅቱ ይውሰዳሉ። ማንኛውም የዋጋ ለውጥ ከለውጥ ውጤታማ ቀን በኋላ ለአካውንትዎ ያለውን የሶስተኛ ወገን ክፍያ ይመርከታል።',
    block13:
      '(d) ጉዳዮች እና ቀያዳ ሙከራዎች። የከፍተኛ ወይም የግብር ክፍያዎችን ማጨረስ ከፈለግዎት፣ እባክዎት በሲክሪፕት ቀን ለሶስት ሰላሳዎች (30) ቀናት ውስጥ contact@noam.tools ላይ ማግኘት ይከተሉ።',
    block14:
      '(እ) ሙፍ ጥቅም ላይ ቀይር. ነፃ ክሪዲቶችን ለማግኘት ብዙ አካውንቶችን መፍጠር አይችሉም። ነፃ ክሪዲቶችን በጥንቃቄ ሳይጠቀም እንደሚያደርጉን መወሰን ከምንችል፣ መደበኛ ክፍያዎችን ሊከፍلكُم እንችላለን ወይም ስέρ್ವሲስ ላይ ገባትን መቆታቸየት ይችላለን።',
    block15:
      'ስرية (Confidentiality). የኖምን ሚስጥራዊ መረጃ ሊከበርዎት ይችላል። ሚስጥራዊ መረጃዎችን独ሽ በእነዚህ ሁኔታዎች ስር በአገልግሎትን መጠቀምን 위한 ብቻ ሊጠቀሙበት ይችላል። ሚስጥራዊ መረጃዎችን ማንም ሌላ ወገን ባለሙያ ላይ መከፋፈል የማይችሉት፣ እና ሚስጥራዊ መረጃዎችን እራስዎን ተመሳሳይ ሚስጥራዊ መረጃዎችን በመጠበቅ የሚያደርጉትን የጠበቅ ሁኔታ ከፍ ያለውን ሁኔታ (ግን በጣም በተቻለ ሥራ) ማጠበቅዎታል። ሚስጥራዊ መረጃ ሙሉ በሙሉ የጋራ ሊያገኙት አይደሉት፣ ይልቁንም የኖም ተብሎ የተመደበውን ወይም በሁኔታው ላይ ሚስጥራዊ እንደሚወሰድ የሚገመጡበትን መረጃ ነው፣ ስለምሳሌ፡ ሶፍትዌር፣ ውጤታማ ሥራዎችን ያሳያል (specifications) እና ሌሎች የግል ሥራ መረጃዎች። ሚስጥራዊ መረጃ የሚያደርግ ስለመሆን የማይችሉትን መረጃዎች ያካትታሉ፦ (1) በእርስዎ ላይ የሌለው ስህተት ሳይኖር በጋራ ለሁሉም ሊያገኙት የሚችሉት፣ (2) በእነዚህ ሁኔታዎች ስር ከመቀበልዎ በፊት ሚስጥራዊ መጠበቅ ኃላፊነት የሌለውን በእርስዎ ባሉት መረጃዎች፣ (3) ሌላ ወገን ባለሙያ ሚስጥራዊ መጠበቅ ኃላፊነት የሌለውን በሕግ የተፈቀደውን ለእርስዎ መረጃ፣ (4) ወይም ሚስጥራዊ መረጃዎችን በማይጠቀም በራስዎ በራስዎ የታዘዘውን መረጃ። ሚስጥራዊ መረጃዎችን ሕግ፣ ዙርያ ወይም ሌላ የመንግስት ትዕዛዝ የሚጠይቁበት ጊዜ ማከፋፈል ይችላሉ፣ ግን በቀድሞ ለኖም በፃፍ ማስታወቅዎት፣ እና ማንኛውንም የሚችሉበትን ጊዜ የማከፋፈል መጠንን ለመቀነስ በተቻለ ሥራ መሥራትዎታል፣ ስለምሳሌ፡ ለማከፋፈል የሚጠየቁትን ጥያቄዎችን ለመቃወም ለኛ እገዛዎታል።',
    block16:
      '(b) ደህንነት። ስέρ్వስটি ለማግኘት እና ለመጠቀም የራስዎን גישהን ለመጠበቅ ምክንያታዊ እና ተገቢ ስርዓቶች መተግበር አለብዎት። ስέρ్వስটির ጥቅም ላይ በመውሰድ ረገድ ማንኛውንም ጉዳዮች ወይም ወንጀልቶች አገኙት የቅርብ ጊዜ内 ኖምን መደውል እና የጉዳይ ወይም የውንጀልቱ ዝርዝሮችን መስጠት አለብዎት።',
    block17:
      '((c) የግለሰብ መረጃ አቀራረብ። የአገልግሎትটን ለግለሰብ መረጃ አቀራረብ ከጠቀምባቸው የቁሳቁስ በሚያስችል የግላዊነት መግለጫዎችን መስጠት እና እንዲህ ያሉ መረጃዎችን ለማቀራረብ ያስፈልጉት እስተማጣቢያዎችን መከացል አለዎት፣ እና እንዲህ ያሉ መረጃዎችን በተሳቢ ሕግ መከሰትዎን ለኛ ተስረክተው ነው።',
    block18:
      'ቆያል; ተጠናቋል። እነዚህ ቃላት ከአገልግሎትዎን የመጀመሪያ ጊዜ መጠቀምዎ በစት ይሠራሉ እና እስከ ቆያል ድረስ ይቆያል። በማቋረጥ የአገልግሎትን እና ይዘትን መጠቀም ማንኛውንም ምክንያት በማንኛውንም ጊዜ እነዚህን ቃላት መቆያል ይችላሉ። ለማንኛውንም ምክንያት በፊት ትእዛዝ እነዚህን ቃላት መቆያል እንችላለን። ለምሳሌ ከክፍል 2 (የመጠቀም መስፈርቶች), ክፍል 5 (ግোጽነት, ደህንነት እና የዳታ ጥበቃ), ክፍል 8 (የጉዳይ መፍታት) ወይም ክፍል 9 (አጠቃላይ ቃላት) በግልጽ መተቋም ቢሆን, ወይም ከምንኛውም የሶስተኛ ወገኖች ቴክኖሎጂ አቅራቢያችንን ከእኛ መቆጣጠር ውጭ ሁኔታ ቢለቀቅ, ወይም ለህግ ወይም መንግስታዊ ጥያቄዎችን መከታተል ቢሆን በማሳየት እነዚህን ቃላት מייחד በቀላሉ መቆያል እንችላለን። እነዚህን ቃላት ከማከተልዎ በማይችልበት ጊዜ, ወይም የመጠቀምዎ ለእኛ ወይም ለማንኛውም ሶስተኛ ወገን የደህንነት κίνδυνο ሊጋሽግልበት ቢችል, ወይም የመጠቀምዎ ሙስና ነው ወይም ለእኛ ወይም ለማንኛውም ሶስተኛ ወገን ሃላፊነት ሊያስተዋውቅበት ቢጠብቅን የአገልግሎት ጣቶችን መቆጣጠር እንችላለን።',
    block19:
      '(b) የመቋረጥ አስተጋብቶች። በመቋረጥ ሲከሰቱ፣ አገልግሎቱን መጠቀም ይቆማሉ እና በእኛ መመሪያ በተመሰረተ ማንኛውም ሚናዊ መረጃዎችን በፍጥነት መመለስ ወይም ማጥፋት ይከተላሉ። በተፈጥሮቷቸው የሚገቡት የዚህ መንገድ አንቀጽዎች፣ በተጨማሪም አንቀጽ 3 እና 5-9ን ጨምሮ፣ መቋረጥ ወይም አጅማሪያ በኋላ ቀሪ ይቆያሉ።',
    block2:
      'ይህ ጥቅም ላይ ጥገኛዎች የኖም አገልግሎቶችን ጥቅም ላይ በመውሰድዎ ላይ ይطبقሉ፣ በኋላም የመተግበሪያ ፕሮግራሞች ኢንተፌስቶች፣ ሶፍትዌር፣ መሳሪያዎች፣ የሠራተኞች አገልግሎቶች፣ ዳታ፣ ማስረጃዎች እና ድህረ ገጽ (አጠቃላይ "አገልግሎቶች" ተብሎ የሚጠራቸው) ይገኙ። በአገልግሎቶችን ጥቅም ላይ በመውሰድዎ የእነዚህን ሁኔታዎች መከተልዎን συμφωνي ያደርጋሉ። የግላ መብት ፖሊሲ የግላ መረጃ እንዴት እንሰበስ እና እንዴት እንጠቀማለን ማብራሪያ ይሰጣል።',
    block20:
      'ኢንዴምኒፊኬሽን። አገልግሎትን በመጠቀምዎ ምክንያት ወይም与之相关联 ሆኖ የሚነሳ ማንኛውንም ግቤታዎች፣ ድሮዎች እና ወጪዎች (ከአቀራረብ ሙከራዎች ጋር ጋር)፣ እርስዎን ይዘትዎን፣ አገልግሎት与之相关联 ያለባቸውን ምርቶች ወይም አገልግሎቶች መጠቀምዎን እና እነዚህ ደንጋጌዎች ወይም ተግባር የሚሆኑን ህግ ማጥፋትዎንም ለእኛ፣ ቅርቶችን እና ሰራተኞችን እርዳታ ያድርጉ፣ ጥቅም ላይ ውሉ፣ እርዳታ ያድርጉ።',
    block21:
      '(፡) ልቀቶች። አገልግሎቱ "እንደ እሱ" ይሰጣል። በህግ የተፈቀደው ደረጃ ውስጥ፣ እኛ፣ ቅንሳቅንሶቻችን እና ማፍቻዎች ስለ አገልግሎቱ ማንኛውንም አይነት ጽንሰ-ሀሳብ ወይም ዋስትና አይሰጣቸውም እና ዋስትናዎችን አይሰጣቸውም፣ በኋላ የተጠቀሙትን ገበያዊነት፣ ለ特定 ህدفት ተገቢነት፣ የ ικανοποιητική ጥራት፣ የመከልከል የለሽነት እና የደህና ሙቀት ዋስትናዎችን ጨምሮ፣ እንዲሁም በመካከል ስርጭት ወይም በንግድ ጥገና ምክንያት የሚነሳውን ማንኛውንም ዋስትና። አገልግሎቱ ቢያንስ ያልተቋረጡ፣ ትክክለኛ ወይም ስህተት የሌለው ይሆናል ወይም ማንኛውንም ይዞቷል ይጠብቃል ወይም ይለወጣል አይደለም ብንለው አይያዝም።',
    block22:
      '(c) LIABILITY ማወቅ. እኛ፣ ቅንሳቄዎቻችን ወይም ማስፈጸሚያዎቻችን በማንኛውም ሚዛን ሊያስፈፅም የለብንም፣ ልዩ፣ ተከተሎች ወይም ማስፈንጸሪያ ጉዳዮች፣ እንደ רዕዝ ቅነሳ፣ ስም ቅነሳ፣ መጠቀም ቅነሳ፣ ዳታ ቅነሳ ወይም ሌሎች አልተለመዱ ኪሳሎች፣ እንኳን እኛ እንዲኖር የሚችልነት ተነግሯል ቢሆንም። በእነዚህ መሠረቶች ላይ፣ አጠቃላይ LIABILITY የምንጠይቀው በዙሪያ (12) ወርሶች ውስጥ ከእርስዎ በክፍያው ለአገልግሎት ከክፍያዎች ወይም አንድ መቶ US ዶላሮች ($100) በላይ չիሆን፣ ማንኛውም ከሌላው ከፍልተኛ ነው። በዚህ ክፍል ውስጥ ያሉት ማወቅዎች በሚተገበርበት ሕግ መቼም በከፍተኛ ደረጃ ይተገበራሉ።',
    block23:
      'የቃል ሕግሶች እና የእርስዎ የአገልግሎት መጠቀም በአሜሪካ ህገ፦ ይመራባል፣ የአሜሪካ ህጎች ተጋጋሚ ህግሶች မှလွဲ၍። የአፕሊኬሽን መጠቀምዎ ሌሎች አከባቢያዊ፣ ህገታዊ፣ ብሔራዊ ወይም መከለከያ ህገ፦ ሊከተሉ ይችላል። ከእነዚህ ቃላት ጋር የተዛመደ ማንኛውም ህጋዊ እርምጃ ወይም ሂደት በአሜሪካ ሕጋዊ ቤቶች ውስጥ ብቄላ ሊመጣል ይገባል፣ እና በእነዚህ ቤቶች ሕጋዊ ኃላፊነት ስር ተመዝግበትዎታል።',
    block24:
      'እኛ መካከል ያለው ግንኙነት። ኖም እና እርስዎ ነጻ ተሠራሾች ነዎት፣ እናም በሌላው ገጽታ ቀድሞው የጽሑፍ ጥራት ያለውን συγκατάθεση ሳይኖርም የአንዱ ገጽታ ሌላውን ገጽታ የሚወክል፣ የሚያገናኘ ወይም ለሌላው ገጽታ ድርጊት የሚወሰን εξουσία የለውም።',
    block25:
      '(፡) የቅርንጫት አጠቃቀም፡፡ ከፍለጋዩን ቀድሞ የጽሑፍ ጥሪ ያለဘဲ Noam ወይም የእሱ ባለሙያ ኤፌሊየሽንስ ስም፣ ሎጎዎች ወይም የንግድ ምልክቶችን መጠቀም አይችሉም።',
    block26:
      'ይህንን ሁኔታዎች መግለጫ አንዱ ያልተፈቀደ፣ ያልተቀጣይ ወይም የማይተገበረ ተብሎ ተወሰነች ቢሆን፣ የቀሙት መግለጫዎች ሙሉ ሥራ እና ተግባር ይይዙበታል።',
    block3:
      'እርስዎ 18 ዓመት በታች ከሆናችሁ፣ አገልግሎትን ለመጠቀም የእናትዎ ወይም የሕግወጥ ጊዜያን ግቦት መሳደብ አለብዎት። አገልግሎትን በከሌለው ሰው ወይም ንቡድር መሆኑ ስላገለግሉ፣ እነዚህን ሁኔታዎች በእኛ ሙሉነት ተቀበልበት መፈቀድ አለብዎት። አካውንትን ለመመዝገብ ትክክለኛ እና ሙሉ መረጃ መሰረጨት አለብዎት። የግባታ ማስተማሪያዎችን ወይም አካውንትዎን ከኢንስታንስዎ ውጭ ለማንም መስጠት አይችሉም፣ እና የግባታ ማስተማሪያዎችን በመጠቀም የተደረገውን ሁሉንም እንቅስቃሴ ይጠየቁታል።',
    block4:
      '(አ) አገልግሎትის አጠቃቀም። እርስዎ ሙሉ በሙሉ የዚህ መንገድ በኩል አገልግሎትին መድረስ ይችላሉ፣ እናም እርስዎን ለአገልግሎት አጠቃቀም የማይጋራ መብት እንሰጥyoruz። አገልግሎትን በሚጠቀምበት ጊዜ፣ እርስዎ የዚህ መንገዶችን እና ሁሉንም ተግባራማ ቅንሶች ተከትለው ይሠሩ። እኛ እና ባልሆኑት በአገልግሎት ውስጥ ሁሉንም መብቶች፣ ሽልማቶች እና ፍላጎቶች ይครፉ።',
    block5:
      'አስተያየት። አስተያየት፣ አስተያየት፣ ሀሳብ፣ እባኮዎች እና ማሻሻያዎችን እንቀበላለን። የእንደዚህ ዓይነት ይዘትን ከሰጡ ከሆነ፣ ምንም ገደብ ሳይቀር እና ምንም ሕገፍ ሳያገኙ መጠቀም እንችላለን።',
    block6:
      '(።) ገደቦች። እርስዎ መሳካት አይችሉም፦ (1)  አገልግሎትን በአንዱ ስሕተት ሊፈጠርበት፣ ሊስጡበት ወይም ሌሎች ሕክምናዎችን ሊละበስበት የሚችል መንገድ ጥቅም ላይ አBringing; (2) የአገልግሎት ሞዴሎች፣ አልጎሪዝሞች እና ስርዓቶችን ምንጭ ያስተካክል፣ ሳርጌን፣ መሰብሰብ፣ ትርጉም ማድረግ ወይም በሌላ ሁኔታ ምንጭ ስርስር ወይም መሠረታዊ አካላትን ለማግኘት ሙከራ ላይ ሊውሉ (ነበር፣ የሚከተለው ገደብ በተሳካ ሕግ የተከፈለለ ከሆነ)። (3) የአገልግሎት ውጤቱን በኖም ጋር ተደጋጋሚ ሆነው ሞዴሎችን ለማዳበር መጠቀም። (4) አገልግሎት ውስጥ ከተገኙው መረጃዎችን ወይም ውጤቶችን በአፕአይ (API) ሊፈቀደው ከሆነ በማስገድድ፣ በድር ማግኘት ወይም በድር መረጃ ማግኘትን ጨምሮ በማንኛውም ተሽከርካሪ ወይም ፕሮግራም ሚዛን ያለበት መንገድ መሰብሰብ። (5) የአገልግሎት ውጤቱን በተራዘም ሲፈጠር አልነበርም ሆኖ ማግለጫ ማድረግ ወይም በሌላ ሁኔታ የእኛን ጥቅም ላይ ስሕተት ሊፈጠርበት። (6) ከእኛ ጥንቃቄ ሳይኖር API ቁልፎችን ገዛ፣ ሽያጭ ወይም ማስተላለፍ። ወይም (7) ከ13 ዓመታት በታች ያሉ ልጆች ወይም የዲጂታል ጥንቃቄ ተገቢ ዕድሜ ያላቸው ልጆችን ማንኛውም የግለሰባዊ መረጃ እንዲከተልን መስጠት። በዱካ መጠን ውስጥ እና በዘፈቀደችን ውስጥ በሚገኙት ሌሎች መስፈርቶች መከተልዎታል።',
    block7:
      '(d) ሦስተኛ ወገን አገልግሎቶች። አገልግሎት ጋር የተዛመደ የማንኛውም ሦስተኛ ወገን ሶፍትዌር፣ አገልግሎት ወይም ሌሎች ምርቶች በራሳቸውን ሁኔታዎች ይወሰዳሉ፣ እናም ለሦስተኛ ወገን ምርቶች አያልተናግረንም።',
    block8:
      '(አ) የእርስዎ ይዘት። እርስዎ ማስገቢያ ("Input") ለአገልግሎት ማቅረብ ይችላሉ እና በማስገቢያው ላይ በመመርከት የተፈጠረ እና የተመለሱውን ማውጫ ("Output") ማግኘት ይችላሉ (አጠቃላይ "ይዘት" ተብሎ የሚጠራሉ)። በክፍሎች መካከል፣ እና በተሳትፊ ሕጎች የተፈቀደው ደረጃ፣ እርስዎ ሁሉንም ማስገቢያዎች ይملكሉ። ኖም ለአገልግሎትን መስපር እና መጠበቅ፣ ለተሳትፊ ሕጎችን መከበር እና የእኛን ፖሊሲዎችን ማከናወን ይዘት መጠቀም ይችላል። እርስዎ በይዘት ሀላፊ ናችሁ፣ እንዲሁም እሱ የተሳትፊ ሕጎችን ወይም እነዚህን ቃላት ሳይከፍተው መጠበቅን ያከናወናሉ።',
    block9:
      '(b) ትክክለኛነት። արհեստական ብሔራዊ እውቀት እና ማሽን ማለቂያ በፍጥነት እድገም ላይ 있는 ምርምር መስኮች ናቸው። አገልግሎታችንን ትክክለኛ፣ ደህንነታማ፣ ደህንነታማ እና ጥቅምሌላ ያደርጋለን። ማሽን ማለቂያ ሁኔታዊ ባህሪ ስላለው፣ አገልግሎታችንን መጠቀም በአንዳንድ ሁኔታዎች ውስጥ የማይሰራውን ውጤት ሊያስገኙ ይችላል፣ ይህም እውነተኛ ተናጋሪዎችን፣ ቦታዎችን ወይም እውነታዎችን በትክክል አይያንሰግምም። በተጠቃሚነትዎ ላይ በመመርከት፣ ጨምሮ በእጅጉ ማጣቀሻዎችን ማጣቀሻዎችን፣ ማንኛውንም ውጤት ትክክለኛነት በተገቢ ሁኔታ ማወቅ አለብዎት።',
    subTitle1: 'መመዝገብ እና ግባ',
    subTitle10: 'ቅጽሎነት',
    subTitle2: 'ጠቀም ማስፈላጊያዎች',
    subTitle3: 'ይዘት',
    subTitle4: 'ፊዚሶች እና ገዢ',
    subTitle5: 'ግোপনীয়ነት፣ ደህንነት እና տվյալների መጠበቅ',
    subTitle6: 'የጊዜ ወገድ እና ሙሉ መቋረጥ',
    subTitle7: 'የአሳዛዥነት ስምምነት; ምክር ማስተናጎቂያዎች; የልይወጣ መልስ ገደቢያ',
    subTitle8: 'ንዋቂው ሕግ እና የፍርድ ባቄያ',
    subTitle9: 'የአጠቃላይ ሁኔታዎች',
    title: 'የአገልግሎት ሁኔታዎች',
    updateTime: 'የተሻሻሉ: ማርች 15, 2024',
  },
  trialModal: {
    btn: 'አሁን ይጀምሩ (ምხოლოდ $0.99)',
    chat: 'ChatPDF',
    desc1: 'ጠይቶዎ በኋላ፣ ዓመታዊ ክፍያ $180 ይፈጠራሉ',
    desc2: 'በማንኛውም ጊዜ ማሰናσል',
    focus: 'ማተኮር',
    hover: 'ሆቨር ትርጉም',
    image: 'ምስል ትርጉም',
    installBtn: 'አሁን ይጫኑ የስጦታዎን ለመቀበል',
    memo: 'የየምዘናዎች አስተዳደር',
    pdf: 'ፒዲኤፍ ሁለገብ ትርጉም',
    realtime: 'ኢንስታንት ትርጉም',
    select: 'ቃላት ምረጥ ትርጉም',
    title: 'እንኳን ደህና መጡهد አስተጋቢ',
    trialText: '7 ቀናት ሙከራ',
    video: 'ቪዲዮ ትርጉም',
    videoSummary: 'ቪዲዮ ጠቅላላ ገጽ',
    web: 'ባለፉት ትርጉም',
    webSummary: 'የዌብ ስርጭት',
  },
  upgradeModal: {
    btn: 'አሁን ዘመር አድግሟል',
    chat: { free: 'ChatPDF ገደብዎን ደረሰናል', pro: 'የዚህ ወር የ ChatPDF ገደብ አድርገዋል' },
    contactStr: 'የሚቀጥሉትን ሪሴት ይጠብቁ ወይም በ contact@noam.tools ይደውሉን።',
    limitAlertStr: 'አቶም ነፃ ፕላን ውስጥ ያለው ገደብዎን ደረሱኸው። ለመቀጠል ደረጃውን ያሻሽሉ።',
    more: 'ዕቃዎችን ይመልከቱ',
    pageLimit: { free: 'PDF ገጽ ገደብዎን ደረሰናል' },
    title: 'ማስታወሻ',
    upgradeAlertStr: 'አፈፃፀም ፕላን ሊሚትዎን ደረሰሃል። እንದυν продолжать ያስጀምሩ።',
    upload: { free: 'PDF ትርጉም ገደብዎን ሰብረዋል', pro: 'የዚህ ወር ለ PDF ትርጉም ገደቡን ሰጡኸው ነው' },
  },
  welfare: {
    newUser: {
      joinBtn: 'አሁን ይቀላቀሉ',
      label: 'አዲስ መጠቀሚያ ጥቅሞች:',
      remain: 'ምርቶ 30 ብቻ ተቀርቷል',
      text: 'ሚገኙት ቦታዎች 100 ብቻ ናቸው! አሁን ራስዎን ይጠቀሙ!',
    },
  },
  aiPdfTranslator: {
    title: 'ነጻ AI PDF ትርጉም መተግበሪያ: በማንኛውም ቋንቋ ውስጥ ከዝርዝር ጋር PDF ትርጉም',
    desc: 'PDF ፋይሎችን በ AI በቀላሉ ወደ ማንኛውም ቋንቋ ይተርጉሙ። የኢንሪጂናላውን እና የተተረጎመውን ጽሑፍ በአንድ ላይ ያወዳዳሉ፣ ፈጣን እና ነፃ።',
    keywords: 'GPT-4፣ AI ሙከራኪ፣ ትርጉም፣ ጠቅላላ ገጽ፣ ማተኮር፣ ChatPDF፣ ሚሞ፣ ቀለጣ',
    sourceToTarget: {
      title: 'ፍሪ PDF ትርጉም መሳሪያ: {{source}}ን ወደ {{target}} ትርጉም አድርግ ፍሪ',
      desc: 'ፒዲኤፍ ፋይሎችዎን ማንኛውም ምንጭ ቋንቋ ወደ የምርጫዎት ቋንቋ ሙፋዋዊ በመተርጎም። ፈጣን፣ ትክክለኛ እና ደህንነቱ የተጠበቀ የፒዲኤፍ ትርጉም በፋሽናል AI የተጎላበተ ነው።',
    },
    headerIntroduce: {
      title: 'ኖም: ከመገላበሪያው በላይ ብቻ የሆነው በመስመር ላይ ትርጉም',
      introduce1: {
        title: 'ኖም · ፒዲኤፍ ፣ሪዳር',
        desc: '✨አንድ ላይ ከሌላ ጋር ትርጉም + AI ጥያቄዎች እና መልስዎች። ፒዲኤፍን በፍጥነትና በትክክል ወደ ዒላማዎት ቋንቋ ትርጉም ያድርጉ። ይፋወሩ የይዘት সম্পর্কে ጥያቄዎችን ይጥሉ የፒዲኤፍ ፋይሎችዎን ጥልቅად ለመረዳት።',
      },
      introduce2: {
        title: 'ኖም · በአንድ ላይ ትርጉም ስፔሺል',
        desc: '👏ሁሉንም የድር ገጽ ማተርጎም нуዶችዎን ይፈታኩ።',
        detail1: { title: 'ወብ ገጽ ትርጉም:', desc: 'አንድ ላይ ከሌላ ጋር ባለሁለት ቋንቋ እይታ' },
        detail2: { title: 'ቃላት ትርጉም:', desc: 'አንድ ክሊክ ፈጣን ትርጉም' },
        detail3: { title: 'ከፍጣን ትርጉም:', desc: 'ቃላት ወይም ዓረፍተ ነገሮችን ወዲያውኑ ተርጉም' },
        detail4: { title: 'ምስል ትርጉም:', desc: 'ምስሎችን ተርጓሚ ማሳያዎች ለተቀይሯል።' },
        detail5: { title: 'ቪዲዮ ትርጉም:', desc: 'ተሻሻሉን እንዲተነብቡ የሚረዳ ባይሊንግዋል ተርጓሚዎች።' },
        footer: 'በပိုမိုສະຫຼາດ الترجمةအတွက် AI-အင်အားပေးသော စာဖတ်ခြင်းအင်္ဂါရပ်များကို ကြုံဖူးပါ!',
      },
    },
    subtitle: 'ፒዲኤፍን በመስከረም በነጻ ተርጉም',
    introduce: {
      module1: {
        detail1: {
          title: 'ከአንድ ጊዜ በአንድ ጊዜ በአጠገብ ጋር PDF ትርጉም',
          desc1: 'የአصل እና የተተረጎመ ይዘት በአንድ ጊዜ ተመሳሳይ እና በጎራ-ጎራ ስርጭት ማሳያ',
          desc2: 'ስንትንም የማይሰጥ ጉዳት ሳይከሰት ሁለቱንም ድጋፎች በማሽከርከሪያ የሚታዘዙትን ማዞር ይችላሉ',
          desc3: 'ማይለዋወጥ የဖတ်ခြင်း ልቦችን ለማቆየት ተመሳሳይ መቀየባለ ሙሉ መቀየባለ አቀራረብ ይጠብቁ',
        },
        detail2: {
          title: 'ትክክለኛ ይዘት መስማት እና ማረጋገጫ',
          desc1: 'መጠቀም እና የተተረጎመ ጽሑፍ መካከል ትክክለኛ ማካሄድ ለቀላል ማረጋገጫ',
          desc2: 'ማህበራዊው ይዘት ያለው እያንዳንዱ ክፍል በትክክል ተመሳሳይ ነው',
          desc3: 'ተယူಸተኛ ውጤቶች માટે թርጉም ልዩነቶችን በፍጥነት አግኝండ እና አስተካክሉ',
        },
      },
      module2: {
        detail1: {
          title: 'የተգባቡ የአዲስአዲስ AI ሞዴሎች ለትክክለኛ ትርጉም',
          desc1: 'ተርጉም እንቅ cầuዎችዎን ለሚጣጣሙ የአዲስ ዘመን ሙከራ (AI) ሞዴሎች መካከል ይመረጡ',
          desc2: 'የተለያዩ የሰነድ ዓይነታዎች እና ኢንዱስትሪዎች માટે опտիմալ ውጤቶችን ያ确保ሉ',
          desc3: 'የተለየ ሞዴል አማራጮች ለእያንዳንዱ ሁኔታ ተስተካከለ መፍትሄዎችን ይሰጣሉ',
        },
        detail2: {
          title: 'የአራት ጎን AI ትርጉም ለሁሉም የይዘት ዓይነት',
          desc1: 'የእኛ ጠንካራ AI ሞዴል ከፍተኛ ትክክለኛነት እና ተፈጥሯዊ ቋንቋ መረዳትን ያረጋግጣል',
          desc2: 'ሳይንቲፒካል፣ አካዳሚክ እና ፍጠራዊ ሰነዶችን በቀላሉ ይቆጣጠራል',
          desc3: 'ሁሉንም የተርጉሒ ሁከታዎችዎ ਲਈ አስተማማኝ ውጤቶችን ያስተላልፋል',
          desc4: 'አንፃራዊ አገልግሎት ለማሳካት የተለያዩ ይዘት ዓይነቶችን የተចេះሄደ መስተጋብር',
        },
      },
      module3: {
        detail1: {
          title: 'ሥልጠናማ ሰነድ መስተጋብር',
          desc1: 'አဆင့်မြင့် AI ကို ఉపయోగിച്ചு PDF እና ፕሬዚንਟੇਸ਼ን ፋይሎችዎ kanssa ቀላልად ይጻፉ',
          desc2: 'የሰነድ ይዘት ስለፈለጋቸውን ጥያቄዎች በခ Augen순간aneously ጠየቁ እናትክክለኛ መልስዎችን ያገኙ',
          desc3: 'ረጅም ሰነዶችအတွက် လျင်မြန်စွာ အတိုချုပ်အကျဉ်းချုပ်များထုတ်လုပ်ပါ',
        },
        detail2: {
          title: 'የይዘት ቢሆንም ቢሆንም ትንታኔ እና ተስተካክል ውህደት',
          desc1: 'AI-ፀበሌ ግንዛቤ በመጠቀም ዋና መረጃዎችን መወሰን እና ውስብስብ ዳታዎችን ማሰላት',
          desc2: 'ቴክኒካል, አካዳሚክ ወይም креатив ቁሳቁሶች ውስጥ ትንታኔዎችን ያግኙ',
          desc3: 'ፕዲኤፍ ትርጉም ማሽንያችን ጋር ተጓዳኝነት በማይጎድቅ የጽሑፍ አስተዳደር ሙሉ办理方案ን ለማግኘት ያገናኝል',
        },
      },
      module4: {
        detail1: {
          title: 'PDF ትርጉም ያላ അധികം: አንድኛ ሁሉ የድህረ-ገጽ ትርጉም መፍትሄ',
          desc: 'በእያንዳንዱ የኦንላይን ጽሑፍ ሁኔታ ለተዘጋጀ የአንድ ከሌላ ጎን ጽፈት ኃይለኛ ትርጉም ስፔሺያልን ይكتشفሉ።',
          desc1: 'ወብ ገጽ ትርጉም: በአንድ ጊዜ በጎን ትጋበዙ ባለሁለት ቋንቋ ይዘትን ያደርጉታል',
          desc2: 'ቃላት ትርጉም: በአንድ ክሊክ በቀላሉ የተሸጠ ሃሳቦችን ትርጉም ያድርጉ',
          desc3: 'ኢንስታንት ትርጉም: ለፍጥነት መረዳት ማድረግ የማንኛውን ጽሑፍ ወይም ዓረፍተ ነገር በአሁኑ ጊዜ ትርጉም ተርጉም',
          desc4: 'ምስል ትርጉም: መጀመሪያውን ምስሎች በተርጓሚ גרסאות በራስ 자동 ይተካከል',
          desc5: 'ቪዲዮ ትርጉም: ለተሻሻለ ልብሳት በሁለት ቋንቋ ትኩረት ቪዲዮዎችን ይመልከቱ',
        },
      },
    },
    question: {
      title: 'ተደጋጋሚ ጠየቀ ጥያቄዎች',
      answer1: {
        title: 'ኖም ፒዲኤፍ ትርጉም መተግበሪያውን ፒዲኤፍ ትርጉም ለማድረግ ነጻ ነው የ사용 መቻላችሁ?',
        content:
          'አዎ, በ Sider PDF Translator በነጻ ሊተርጉሙ የ PDF 文件ዎች ይችላሉ! 5,000 ቶከንን ነጻ ክፍያ እንሰጣለን, ይህ በገበያတွင በተለምዶ የሚገኙ רוב አነስተኛ የ PDF 文件ዎችን ለመተርጉም በቂ ነው። የበড辘 文件ዎችን ለመተርጉም ወይም የርቀቀ ማህደራዎችን ከፈለግዎት, ပိုမို စွမ်းရည်များအတွက် ကျွန်ုပ်တို့၏ ሙያ ዕቃዎችသို့ ደረጃ உயரಿಸရန် ရွေးနိုင်ပါသည်။',
      },
      answer2: {
        title: 'ኖም ፒዲኤፍ ትርጉም መተንተን እত որքա ትክክል ነው?',
        content:
          'Noam PDF ትርጉም መሳሪያ በከፍተኛ AI ቴክኖሎጂን በመጠቀም እና በመጨረሻዎችን በጥሩ ሁኔታ መረዳት ద్వারా በጣም ትክክለኛ ትርጉሞችን ይሰጣል። ምንም በራሱ የሚሰራ ትርጉም ምንም ቀንድ የሆነ አይደለም ቢሆንም የእኛ በአንድ ላይ ዳሽፕሌይ እያንዳንዱን ትርጉም በቀላሉ ማመርማር እና ማሻሻልዎን ይፈቅዳል፣ የመጨረሻ ውጤቱ የጥራት ዓላማዎችዎን ለመሙላት ይረዳል። በ Noam ያለውን የተማመን እና ትክክለኛ PDF ትርጉም ይጠብቁ።',
      },
      answer3: {
        title: 'ስካን የተሰከሉ ፒዲኤፍ ቃላት መተርጎም შემიძლ ли?',
        content:
          'አዎ, በከባድ የተያዘ OCR (Optical Character Recognition) ቴክኖሎጂ በኩል የተስክን ማጣሪያዎችን (PDFs) መተረጎም ይችላሉ። ስርዓታችን በራስ ሁሉ የተስክረው ሰነዶች እና በምስል ላይ የተመሠረተ PDF ቅጽሎች ውስጥ ያሉ ጽሑፎችን ይወሰዳል, ከዚያ ይህን ይዘት ለእርስዎ ይተረጎማል። ይህ ያስከትላል እንኳን የማይቀይር ወይም በምስል ብቻ የተቀመጡ PDF ቅጽሎች በትክክል ይተረጎማሉ።',
      },
      answer4: {
        title: 'ትርጉም ለማድረግ ሰንዴት ይወስዳል?',
        content:
          'ትርጉም በፍጥነትና በምርጫታ ይደረጋል—አብዛኛዎቹ ጽሑፎች በሰከንዶች እስከ ወደኛዎች ወሰንታት ውስጥ ይобработሉ, ይህ በዕሬታቸው እና ውስብስብতቸው ላይ የተመሠረተ ነው። ለምሳሌ, መደበኛ 10-ገጽ PDF ብዙውን ጊዜ ከ2 ወሰኑ በታች ይጠራል። ለሁሉም የጽሑፍ ትርጉም እንቅስቃሴዎች 빠른 ጊዜ ያጋጥሉ!',
      },
      answer5: {
        title: 'መጽሐፍ읽ን 위한 በአንድ ላይ ትኩረት አሳይቶ መቆየት ይችላኛሁን?',
        content:
          'አዎ, መረጃዎችዎን ሁልጊዜ በአንድ ላይ ተጣጣኝ ማንበብ ይችላሉ። ይህ አቀማመጥ ሙሉ እና ተርጉም ይዘትን በቀላሉ ማසተካከል ይቻላል, ይህም ለስላሳ እና ሥነ-ስር የማንበብ ልምድን ይጠበቅላል።',
      },
    },
    freeTrial: 'ፍሪ ታሪካል',
    toLanguage: { title: 'ፒዲኤፍ AI ትርጉም ጥንድቶች', item: '{{target}}' },
  },
  aiPdfTranslate: {
    header: {
      features: 'ምيزቶች',
      pricing: 'ዋጋ መወሰን',
      blog: 'ብሎግ',
      faq: 'የተደጋጋሚ ጥያቄዎች',
      button: 'አሁን ትርጉም አድርግ',
    },
    hero: {
      upload: {
        title: 'PDF።ን ይከላከሉ',
        highlight: 'የማናሸገር ለማየት ክሳፍ',
        max: 'ማክስ',
        desc: 'ወይም ይጎትሙ እና ይጣሉ',
      },
      to: 'ለ',
      title: 'ፍሪ PDF ትርጉም መተላለፊያ',
      pill: 'AI-ተጭነcted የፒዲኤፍ ትርጉም መተግበሪያ',
      model: 'GPT-4 እና Claude',
      support: 'OCR ድعم',
      free: 'ፍሪ ታይራል',
      complete: 'ትርጉም ສຳເລັດ',
      translated: 'በኖም ተርጓሜ',
      desc: 'ስንትከፍት፣ ትክክለኛ ትርጓሜዎች እነሱ የመጨረሻ አወቃቀርን ይጠብቃሉ። Noam AI OCR እና ጎን-የጎን አሳሳቢዎችን ይደግፋል።',
    },
    ticker: {
      pdf: 'ፒዲኤፍ ትርጉም',
      ocr: 'OCR τεχνολογία',
      side: 'በጎረመጃ',
      multi: 'ብహుళ ቋንቋ',
      chat: 'PDF ጋር መደምደም',
      format: 'ፎርማትን ማቆየት',
      web: 'ዌብ ትርጉም',
      secure: 'ተጠበቀ እና የግላβሪ',
    },
    comparison: {
      bad: {
        title: 'ዋና መተርጎም',
        head: 'ፊርማቲንግ እና კონტექስት ጠፈርቷል',
        text1: 'ስህተት: መዋቅር ሙሉሉ። ምስሎች በተሳሳተ ቦታ ተቀምጦዋል።',
        text2: 'ጽሑፎች ይዘናကြပြီး ፎንቶች አጋጣሚ ናቸው። ያንቀጽቃሽ ሆኖ አዕቃዊ አይደለም...',
      },
      dump: { title: 'ቀጣይ ጽሑፍ መልቀቅ' },
      good: { title: 'ኖም AI ትርጉም', tag: 'አጠቃላይ ውጤት', sub: 'ስተሳቢ ፎርማቲንግ, ስማዕት ስማዕት' },
      title: 'አንዴ ሎም AIን ለምንም ይምረጣሉ?',
      desc: 'ኮፒ-ፓስት ትርጉም ላይ በሚጫወተው ይቆጣጠሩ። መደበኛ መሳሪያዎች እና አካል-ተጎላበተውን ሁኔታ-ተገቢ ትርጉም መካከል ያለውን ልዩነት ይጠይቁ።',
    },
    showcase: {
      kicker: 'ደገፈ ሰነዶች',
      title1: 'ማንኛውም ሰነድ',
      title2: 'ከሆነም ቋንቋ',
      carousel1: 'አርት',
      carousel2: 'አርኪቴክቸር',
      carousel4: 'መድሃኒት',
      carousel5: 'ፋይናንስ',
      note: 'ቴክኒካል፣ አካዳሚክ እና ፍኬታማ ሰነዶችን በቀላሉ ይቆጣጠሩ።',
      carousel3: 'አካዳሚክ ጅርና ጥቅሳት መጽሐፍ',
      carousel6: 'ዘመንዳት',
      carousel8: 'ፖሊሲ',
      carousel7: 'የስምምነት ውثيት',
    },
    features: {
      big: {
        title: 'የአዲስ ዘመን AI ሞዴሎች (GPT-4, Claude)',
        desc: 'ፅለቶችዎን ተስማሚ ለማድረግ ከወሳኝ AI ሞዴሎች መካከል ይመረጡ። ለዓይነት የጽሑፍ አይነታዎችን ተገቢ የሆኑ ውጤቶችን ያረጋግጡ።',
      },
      grid1: {
        title: 'OCR ድعم',
        desc: 'ተስክን እና ምርጫዎችን ከተስክሮት ናቸው ፒዲኤፍ እና ምስሎች በስቀኑ የጽሑፍ መቀየሪያ እና ትርጉም ይሰጡ።',
      },
      grid2: {
        title: 'ሙሉ ሪዛሲን የሚመልሰው ልኬት',
        desc: 'የተተርጓመውን ደነቆ ሰነዶችዎን በ PDF ቅጽ እና በአንደነበራቸው መደበኛ ለይ out ሙሉ ያውርሱ።',
      },
      grid3: { title: 'አንድ ላይ አንድ ማነፃፀር', desc: 'የመነሻ እና የተተረጎመ ጽሑፎችን ለማසወσοድ የተመሳሰለ መዝገብ' },
      title2: 'እሱ አብዮት ነው',
      line1: 'ቴክኒካል ፔፕር.pdf',
      title1: 'ተርጉም ብቻ ባይሆን ፣ ተጨማሪ ነገሮች',
      line2: 'ቋንቋ መለየት: እንግሊዘኛ...',
      line4: 'ተርጉም ສຳເລັດແລ້ວ (ຄວາມຖືກຕ້ອງ 99%)',
      line3: 'ሞዴል: GPT-4o (ከፍተኛ ትክክለኛነት)',
    },
    testimonials: {
      review1: {
        role: 'ሮሴርችር',
        content:
          'ኖም AI ለአካዳሚክ ጽሑፎችን ትርጉም ላይ ሰዓታትን ማቆየኝ አድርገዋል። የአንድ ከአንድ ጎን እይታ በቴክኒካል ቃላት ማረጋገጥ ላይ በጣም ጠቃሚ ነው።',
      },
      review2: {
        role: 'ዓለም አቀፍ ማርኬታ',
        content:
          'እኔ የጠቀሙት በጣም ጥሩ የፒዲኤፍ ትርጉም መተግበሪያ ነው። የኢዮኒካል ቅጽፍን በፍጹም ጥራት ይጠብቃል፣ ይህም ለማርኬቲንግ ደክቶች በጣም አስፈላጊ ነው።',
      },
      review3: {
        role: 'ቀንድ ሙከራዊ ሶስት',
        content:
          'አካርተኛ እና ፈጣን ነው። ውልያዎችን ትርጉም ለማድረግ እና ስካንናረደው ደብተሮችအတွက် OCR ባህሪው ተስማሚ በሆነ መንገድ ይሠራል።',
      },
      kicker: 'በተጠቃሚዎች የተወዳደሩ',
      title: 'የተጠቃሚዎቻችን ምاذا ይናገሩ',
    },
    cta: {
      title: 'ቋንቋ ባሉሉን መበረራ እየወግደστε?',
      button: 'ነፃ በማድረግ Übersetzung սկսել',
      desc: 'ተጠቃሚ 10,000+ ይሁኑ እና ዛሬከሁሉም Noam AI በመጠቀም ሰነዶችዎን መተርጎም ይጀምሩ።',
      hint: '',
    },
    languagePairs: {
      title: 'እንግሊዘኛ PDF AI ትርጉም ጥንድቶች',
      desc: 'ኖም AI የተደገፈውን የተሠራተኞች የትርጉም አቅጣጫዎች',
    },
    footer: { about: 'እኛስ በተመለከተ', privacy: 'ግላዊነት ፖሊሲ', contact: 'የደገፊት ስፖርትን አግኝ' },
  },
}

export default TRANSLATION
